/* eslint-disable react-hooks/exhaustive-deps */
import { useParams, useLocation, useNavigate } from "react-router-dom";
import React, {
  lazy,
  Suspense,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Row,
  message,
  Card,
  Typography,
  Col,
  Divider,
  Popconfirm,
  Button,
} from "antd";
import {
  ScanOutlined,
  AppstoreAddOutlined,
  InsertRowBelowOutlined,
  BorderBottomOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { useAuth } from "../../../AuthContext";
import { accionConfig } from "../../../utils/getAccionConfig";
import GETDetalleAuditoriaSMA from "../../../helpers/auditoria-sma/GETDetalleAuditoriaSMA";
import PUTCompletarAuditoriaSMA from "../../../helpers/auditoria-sma/PUTCompletarAuditoriaSMA";
import HeaderBack from "../../../components/layout/headers/HeaderBack";
import AppLayout from "../../../components/layout/AppLayout";
import Loader from "../../../components/loader/Loader";
import PUTIniciarAuditoriaSMA from "../../../helpers/auditoria-sma/PUTIniciarAuditoriaSMA";
import { Modal } from "antd";
import { PUTPausarAuditoriaSMA } from "../../../helpers/auditoria-sma/PUTPausarAuditoriaSMA";
import GETTiposPalet from "../../../helpers/auditoria-sma/GETTiposPalet";
import PaletCard from "./paletizado/PaletCard";
import GranelCard from "./GranelCard";
import TodosCard from "./TodosCard";
import TabSelector from "./TabSelector";
import {
  calcularCapacidadPalet,
  getColorEstado,
  getTotalAuditadoYConteoPalets,
  handleLeerCodigosLote,
  tienePendientePaletizable,
  mismoArticuloQuePalet,
  paletsDelArticulo,
} from "./detalleAuditoriaSMA.handlers";
import PaletMultiCard from "./paletizado/PaletMultiCard";
import ManualBarcodeInput from "./paletizado/lote/ManualBarcodeInput";
import { normalizeGS1Barcode } from "../../../utils/checkCodigoPaletLote";
import GETVerificarLoteVto from "../../../helpers/auditoria-sma/GETVerificarLoteVto";
import ModalLoteVto from "./paletizado/lote/ModalLoteVto";
import GETCodigoBarra from "../../../helpers/auditoria/GETCodigoBarra";
import ModalSeleccionVLX from "../modalSeleccionVLX/ModalSeleccionVLX";
import ModalSeleccionSku from "../modalSeleccionSku/ModalSeleccionSku";
import {
  getItemDomId,
  normalizarCodigo,
  parseDiferenciasSMA,
} from "./detalleAuditoriaSMA.utils";
import ModalDiferenciasSMA from "./ModalDiferenciasSMA";

const { Text } = Typography;

const ModalTecladoCantidad = lazy(
  () => import("../../../components/modalTecladoCantidad/ModalTecladoCantidad"),
);

const ModalTecladoAlfanumerico = lazy(
  () =>
    import("../../../components/modalTecladoAlfanumerico/ModalTecladoAlfanumerico"),
);

const ManualPaletForm = lazy(() => import("./paletizado/ManualPaletForm"));

const ManualPaletMultiForm = lazy(
  () => import("./paletizado/ManualPaletMultiForm"),
);

const usaLote = process.env.REACT_APP_USALOTE;

// detart viene como string JSON con las alternativas de artículo para un GTIN.
// Devuelve [] si no hay, si viene vacío o si el JSON viene roto → flujo normal.
const parseDetart = (raw) => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  try {
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
};

const DetalleAuditaSMA = ({ darkMode, setDarkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { idauds } = useParams();
  const query = new URLSearchParams(location.search);
  const jaula = query.get("jaula");
  const esRecepcionMercaderia = query.get("recep");
  const { loggedUser } = useAuth();
  // const { usaModoLote } = useAppVersionContext();

  const [activeTab, setActiveTab] = useState("todos");
  const [loading, setLoading] = useState(true);
  const [procesandoAccion, setProcesandoAccion] = useState(false);
  const [auditoriaSMA, setAuditoriaSMA] = useState(null);
  const [detallesLocal, setDetallesLocal] = useState([]);

  const [tecladoVisible, setTecladoVisible] = useState(false);
  const [auditoriaCompletada, setAuditoriaCompletada] = useState(false);
  const [estadoInicial, setEstadoInicial] = useState([]);
  const [filtroPaletsPorArticulo, setFiltroPaletsPorArticulo] = useState(null);
  const [tiposPalet, setTiposPalet] = useState([]);
  const [alturasPalet, setAlturasPalet] = useState([]);

  const [paletsEnProceso, setPaletsEnProceso] = useState([]);

  const [paletsMultiarticulo, setPaletsMultiarticulo] = useState([]);

  const [paletActivoId, setPaletActivoId] = useState(null);
  const [paletMultiActivo, setPaletMultiActivo] = useState(null); // id del palet multi activo
  const [paletLoteActivo, setPaletLoteActivo] = useState(false); // id del palet lote activo
  const paletLoteActivoRef = useRef(false); // ← Agrega esta ref
  // En el componente padre, agregá este estado:
  const [barcodeData, setBarcodeData] = useState({
    hasData: false,
    values: { cb1: "", cb2: "", cb3: "" },
  });
  // Junto a los otros estados de DetalleAuditaSMA:el palet
  const [codigoDetectado, setCodigoDetectado] = useState(null); // Codigo para PaletLote detectado por Regex

  // Sincroniza la ref con el estado
  useEffect(() => {
    paletLoteActivoRef.current = paletLoteActivo;
  }, [paletLoteActivo]);

  const [configs, setConfigs] = useState([]);

  const [modalPaletMultiVisible, setModalPaletMultiVisible] = useState(false);
  const [modalPaletManual, setModalPaletManual] = useState({
    visible: false,
    item: null,
  });

  const [modalLoteVtoVLX, setModalLoteVtoVLX] = useState({
    open: false,
    items: [],
    ubicacionActual: null,
    sku: null,
  });
  const [modalLoteNombreArt, setModalLoteNombreArt] = useState("");

  // Selección de SKU cuando un GTIN resuelve a más de un artículo (detart > 1)
  const [modalSeleccionSku, setModalSeleccionSku] = useState({
    open: false,
    items: [],
  });
  const resolveSeleccionSkuRef = useRef(null);

  const esperarSeleccionSku = (items) =>
    new Promise((resolve) => {
      resolveSeleccionSkuRef.current = resolve;
      setModalSeleccionSku({ open: true, items });
    });

  const cerrarSeleccionSku = (elegido) => {
    resolveSeleccionSkuRef.current?.(elegido ?? null);
    resolveSeleccionSkuRef.current = null;
    setModalSeleccionSku({ open: false, items: [] });
  };

  // Diferencias que devuelve el backend al rechazar el completado
  const [modalDiferencias, setModalDiferencias] = useState({
    open: false,
    descri: "",
    diferencias: [],
  });

  const [loteVtoActivo, setLoteVtoActivo] = useState(null); // Regula que lote/vto esta activo de un palet personalizado
  const loteVtoActivoRef = useRef(null);

  const detallesRef = useRef([]);
  const bufferRef = useRef("");

  const paletsMultiarticuloRef = useRef([]);
  const paletMultiActivoRef = useRef(null);
  const paletActivoIdRef = useRef(null);

  const scrollContainerRef = useRef(null);

  const codigoPendienteRef = useRef(null); // guarda el item escaneado mientras esperamos el modal
  const [modalLoteVisible, setModalLoteVisible] = useState(false);
  const [loteInput, setLoteInput] = useState("");
  const [vtoInput, setVtoInput] = useState("");

  useEffect(() => {
    loteVtoActivoRef.current = loteVtoActivo;
  }, [loteVtoActivo]);

  useEffect(() => {
    paletActivoIdRef.current = paletActivoId;
  }, [paletActivoId]);

  useEffect(() => {
    paletMultiActivoRef.current = paletMultiActivo;
  }, [paletMultiActivo]);

  useEffect(() => {
    paletsMultiarticuloRef.current = paletsMultiarticulo;
  }, [paletsMultiarticulo]);

  const [modalVisible, setModalVisible] = useState({
    status: false,
    payload: {},
  });

  useEffect(() => {
    setPaletsEnProceso((prev) =>
      prev.map((palet) => {
        if (!palet.esMultiparte) return palet;

        const asignadoPorParte = { ...(palet.asignadoPorParte || {}) };

        palet.partes.forEach((parte) => {
          if (!(parte.idartp in asignadoPorParte)) {
            asignadoPorParte[parte.idartp] = 0;
          }
        });

        return {
          ...palet,
          asignadoPorParte,
        };
      }),
    );
  }, [activeTab]);

  const usedIdsRef = useRef(new Set());

  const generarIdPaletUnico = () => {
    let id;
    do {
      id = Math.random().toString(36).slice(2, 10).toUpperCase();
    } while (usedIdsRef.current.has(id));
    usedIdsRef.current.add(id);
    return id;
  };

  const actualizarEstadoInicial = (detalles) => {
    const snapshot = detalles.map((item) => ({
      idartp: item.idartp,
      nropar: item.nropar,
      sku: item.sku,
      ctdaud: Number(item.ctdaud),
    }));
    setEstadoInicial(snapshot);
  };

  const accionActual = auditoriaSMA
    ? accionConfig[auditoriaSMA.estadoOpe] || null
    : null;

  const ordenActiva = auditoriaSMA ? auditoriaSMA.estadoOpe === "2" : false;

  const hayCambiosPendientes =
    !auditoriaCompletada &&
    (() => {
      if (detallesLocal.length !== estadoInicial.length) return true;
      const estadoActualMap = new Map(
        detallesLocal.map((item) => [
          `${item.idartp}-${item.nropar}-${item.sku}`,
          Number(item.ctdaud),
        ]),
      );
      return estadoInicial.some((item) => {
        const key = `${item.idartp}-${item.nropar}-${item.sku}`;
        const ctdaudActual = estadoActualMap.get(key) ?? 0;
        return ctdaudActual !== Number(item.ctdaud);
      });
    })();

  const iniciarPaletizacion = (item, itemsMultiparte = null) => {
    const esMultiparte = !!itemsMultiparte;

    // Usar idartf para evitar duplicados en grupos
    const yaExistePalet = paletsEnProceso.some((p) =>
      esMultiparte ? p.idartf === item.idartf : mismoArticuloQuePalet(item, p),
    );
    if (yaExistePalet) {
      setActiveTab("palet");
      return;
    }

    // Se resuelve por idartl en granel: con idartp/nropar en null, el find
    // devolvía siempre el primer artículo granel de la lista.
    const itemActual = detallesLocal.find((d) =>
      mismoArticuloQuePalet(d, item),
    );
    if (!itemActual) return;

    const cantid = Number(itemActual.cantid || 0);
    const ctdaud = Number(itemActual.ctdaud || 0);
    const pendienteTotal = Math.max(0, cantid - ctdaud);

    if (pendienteTotal <= 0) {
      message.info("No hay unidades pendientes para paletizar.");
      return;
    }

    const ctdPorPaletRaw = Math.min(
      Number(item.cantid),
      Number(item.ctdmax) > 0 ? Number(item.ctdmax) : Number(item.ctdplt),
    );

    if (ctdPorPaletRaw <= 0) {
      message.error("Configuración de palet inválida.");
      return;
    }

    const ctdPorPalet = ctdPorPaletRaw;

    // Obtener todos los SKUs del grupo desde detallesLocal (fuente de verdad)
    const skusPermitidos = esMultiparte
      ? detallesLocal
          .filter((d) => d.idartf === item.idartf)
          .map((d) => normalizarCodigo(d.sku))
      : [normalizarCodigo(item.sku)];

    const asignadoPorParte = {};
    if (esMultiparte && itemsMultiparte) {
      itemsMultiparte.forEach((parte) => {
        asignadoPorParte[parte.idartp] = 0;
      });
    }

    const nuevoPalet = {
      idPalet: generarIdPaletUnico(),
      idartl: item.idartl,
      idartp: item.idartp,
      idartf: item.idartf,
      nropar: item.nropar,
      sku: item.sku,
      skusPermitidos,
      nombre: item.nombre,
      idpalt: item.idpalt,
      idpala: item.idpala,
      cantid,
      ctdaud,
      pendienteTotal,
      asignado: 0,
      asignadoPorParte,
      paletNumero: 1,
      ctdPorPalet,
      esMultiparte,
      partes: itemsMultiparte
        ? itemsMultiparte.map((i) => ({
            idartl: i.idartl,
            idartp: i.idartp,
            nropar: i.nropar,
          }))
        : null,
    };

    setPaletsEnProceso((prev) => [...prev, nuevoPalet]);
    setPaletActivoId(nuevoPalet.idPalet);
    setActiveTab("palet");
  };

  const iniciarPaletizacionManual = (
    item,
    idpaltSeleccionado,
    idpalaSeleccionado,
    capacidad,
  ) => {
    // Se resuelve por idartl en granel: con idartp/nropar en null, el find
    // devolvía siempre el primer artículo granel de la lista.
    const itemActual = detallesLocal.find((d) =>
      mismoArticuloQuePalet(d, item),
    );
    if (!itemActual) return;

    const cantid = Number(itemActual.cantid || 0);
    const ctdaud = Number(itemActual.ctdaud || 0);
    const pendienteTotal = Math.max(0, cantid - ctdaud);

    if (pendienteTotal <= 0) {
      message.info("No hay unidades pendientes para paletizar.");
      return;
    }

    // Capacidad lógica: no superar lo pendiente
    const ctdPorPalet = Math.min(capacidad, pendienteTotal);

    const nuevoPalet = {
      idPalet: generarIdPaletUnico(),
      idartl: item.idartl,
      idartp: item.idartp,
      nropar: item.nropar,
      sku: item.sku,
      nombre: item.nombre,
      idpalt: idpaltSeleccionado,
      idpala: idpalaSeleccionado,
      cantid,
      ctdaud,
      pendienteTotal,
      asignado: 0,
      paletNumero: 1,
      ctdPorPalet,
    };

    setPaletsEnProceso((prev) => [...prev, nuevoPalet]);
    setPaletActivoId(nuevoPalet.idPalet);
    setActiveTab("palet");
  };

  const handleAccion = async () => {
    if (procesandoAccion) return;
    if (!auditoriaSMA || !loggedUser) return;

    const accion = accionConfig[auditoriaSMA.estadoOpe];
    if (!accion) return;

    setProcesandoAccion(true);
    try {
      let response;

      if (auditoriaSMA.estadoOpe === "1") {
        response = await PUTIniciarAuditoriaSMA(auditoriaSMA.id, loggedUser);
      } else {
        if (accion.accion === true) {
          const norm = (v) => String(v ?? "").trim();
          const normVto = (v) =>
            String(v ?? "")
              .replaceAll("-", "")
              .trim();

          const tieneLoteVto = (d) => !!norm(d.lote) && !!normVto(d.vto);

          const detallesBase = detallesLocal.filter((d) => !tieneLoteVto(d));

          const granelLoteVto = detallesLocal
            .filter((d) => tieneLoteVto(d))
            .map((d) => ({
              idauds: d.idauds,
              afecta: d.afecta,
              idartl: d.idartl,
              idartf: d.idartf,
              idartp: d.idartp,
              codigo: d.codigo,
              sku: d.sku,
              codbar: d.codbar,
              nombre: d.nombre,
              modelo: d.modelo,
              ctdpar: d.ctdpar,
              nropar: d.nropar,
              descri: d.descri,
              cantid: Number(d.cantid ?? 0),
              ctdaud: Number(d.ctdaud ?? 0),
              voltot: d.voltot,
              idpala: d.idpala,
              idpalt: d.idpalt,
              ctdplt: d.ctdplt,
              ctdmax: d.ctdmax,
              lote: d.lote ?? null,
              vto: d.vto ?? null,
            }));

          const payload = {
            id: auditoriaSMA?.id || idauds,
            idOpe: auditoriaSMA?.idOpe,
            estadoOpe: "4",
            numeroComprobanteSMA: auditoriaSMA?.numeroComprobanteSMA,

            detalles: detallesBase.map((d) => ({
              idauds: d.idauds,
              afecta: d.afecta,
              idartl: d.idartl,
              idartf: d.idartf,
              idartp: d.idartp,
              codigo: d.codigo,
              sku: d.sku,
              codbar: d.codbar,
              nombre: d.nombre,
              modelo: d.modelo,
              ctdpar: d.ctdpar,
              nropar: d.nropar,
              descri: d.descri,
              cantid: Number(d.cantid ?? 0),
              ctdaud: Number(d.ctdaud ?? 0),
              voltot: d.voltot,
              idpala: d.idpala,
              idpalt: d.idpalt,
              ctdplt: d.ctdplt,
              ctdmax: d.ctdmax,
            })),

            granelLoteVto,

            paletsEnProceso,
            paletsMultiarticulo,

            idJaula: auditoriaSMA?.idJaula,
            jaula: auditoriaSMA?.jaula,

            configs: configs.map((config) => ({
              idartl: config?.idartl,
              idpalt: config?.nuevoIdpalt,
              idpala: config?.nuevoIdpala,
              capacidad: config?.capacidadDelPalet,
            })),
          };

          response = await PUTPausarAuditoriaSMA(
            auditoriaSMA.id,
            accion.accion,
            payload,
          );
        } else {
          response = await PUTPausarAuditoriaSMA(
            auditoriaSMA.id,
            accion.accion,
            null,
          );
        }
      }

      if (response?.status === 200) {
        const nuevoEstado = accion.accion ? "4" : "2";
        setAuditoriaSMA((prev) => ({ ...prev, estadoOpe: nuevoEstado }));

        if (accion.accion === true) {
          actualizarEstadoInicial(detallesLocal);
        }

        // message.success(
        //   response.data?.descri || "Se cambió el estado de la orden.",
        // );
      } else {
        message.error(
          response.message || "No se pudo cambiar el estado de la orden.",
        );
      }
    } catch (e) {
      console.error("Error al cambiar estado:", e);
      message.error("Error al procesar la acción.");
    } finally {
      setProcesandoAccion(false);
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hayCambiosPendientes) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hayCambiosPendientes]);

  useEffect(() => {
    detallesRef.current = detallesLocal;
  }, [detallesLocal]);

  const abrirTeclado = () => {
    setTecladoVisible(true);
  };

  const getParentPath = () => {
    const segments = location.pathname.split("/").filter(Boolean);

    if (segments.length > 1) {
      segments.pop();
      return "/" + segments.join("/");
    }

    return null;
  };

  const confirmOpenRef = useRef(false);

  const handleGoBack = () => {
    if (confirmOpenRef.current) return;
    const parentPath = getParentPath();

    const goBack = () => {
      if (parentPath) {
        navigate(parentPath);
      } else {
        navigate(-1);
      }
    };

    if (hayCambiosPendientes) {
      confirmOpenRef.current = true;

      Modal.confirm({
        title: "¿Seguro que deseas salir?",
        content: !auditoriaCompletada
          ? "Tienes cambios sin guardar desde la última pausa. Se recomienda pausar la auditoría antes de salir para no perder el progreso."
          : "Estás a punto de salir sin completar la auditoría.",
        okText: "Sí, salir",
        okType: "danger",
        cancelText: "Cancelar",
        onOk() {
          confirmOpenRef.current = false;
          goBack();
        },
        onCancel() {
          confirmOpenRef.current = false;
        },
      });
    } else {
      goBack();
    }
  };

  const handleSelectForPalet = (item) => {
    let itemsMultiparte = null;

    if (item?.ctdpar > 1) {
      // Agrupar por idartf → todas las partes del mismo conjunto
      itemsMultiparte = detallesLocal.filter((d) => d.idartf === item.idartf);
    }

    const tieneConfigPalet =
      item.idpalt && (Number(item.ctdmax) > 0 || Number(item.ctdplt) > 0);

    setFiltroPaletsPorArticulo({
      idartl: item.idartl,
      idartp: item.idartp,
      nropar: item.nropar,
      sku: item.sku,
    });

    if (tieneConfigPalet) {
      iniciarPaletizacion(item, itemsMultiparte);
      return;
    }

    setModalPaletManual({
      visible: true,
      item,
      itemsMultiparte, // Al modal por si se necesita
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await GETDetalleAuditoriaSMA(idauds);
        if (response?.data) {
          setAuditoriaSMA(response.data);

          let detallesFinales = [];
          let paletsRestaurados = [];
          let paletsMultiRestaurados = [];

          if (response.data.ultjsn && response.data.ultjsn.trim() !== "") {
            try {
              const ultjsnParsed = JSON.parse(response.data.ultjsn);

              // Clave para cruzar un detalle del ultjsn con su original del backend.
              // NO se puede usar solo idartp: los artículos granel vienen con
              // idartp en null (LEFT JOIN artpar), así que todos colapsarían a
              // la misma clave "" y el Map solo guardaría el último.
              const claveDetalle = (d) =>
                d?.idartp
                  ? `p|${d.idartp}|${d.nropar ?? ""}`
                  : `l|${d?.idartl ?? ""}`;

              const detallesOriginalesMap = new Map(
                (response.data.detalles || []).map((d) => [claveDetalle(d), d]),
              );

              if (Array.isArray(ultjsnParsed?.detalles)) {
                const detallesBase = ultjsnParsed.detalles.map((dLocal) => {
                  const dOriginal = detallesOriginalesMap.get(
                    claveDetalle(dLocal),
                  );

                  return {
                    ...dOriginal,
                    ...dLocal,
                    sku: String(dLocal.sku ?? "").trim(),
                  };
                });

                const granelLoteVto = Array.isArray(ultjsnParsed?.granelLoteVto)
                  ? ultjsnParsed.granelLoteVto.map((dLocal) => {
                      const dOriginal = detallesOriginalesMap.get(
                        claveDetalle(dLocal),
                      );

                      return {
                        ...dOriginal,
                        ...dLocal,
                        sku: String(dLocal.sku ?? "").trim(),
                        lote: dLocal.lote ?? null,
                        vto: dLocal.vto ?? null,
                      };
                    })
                  : [];

                detallesFinales = [...detallesBase, ...granelLoteVto];
              }

              // if (Array.isArray(ultjsnParsed?.detalles)) {
              //   // Enriquecer cada detalle del ultjsn con los datos completos originales
              //   detallesFinales = ultjsnParsed.detalles.map((dLocal) => {
              //     const dOriginal = detallesOriginalesMap.get(
              //       String(dLocal.sku).trim(),
              //     );
              //     return {
              //       ...dOriginal, // campos completos del backend (voltot, idpala, etc.)
              //       ...dLocal, // sobrescribe con lo modificado por el usuario (cantid, ctdaud, etc.)
              //       sku: String(dLocal.sku ?? "").trim(), // asegurar formato
              //     };
              //   });
              // }

              // Restaurar palets si existen.
              // Hay dos formas guardadas en el ultjsn según qué función lo
              // escribió: la de pausa (paletsEnProceso, con el estado completo
              // del front) o la de completar (palets, solo alias y cantidad).
              // Se leen las dos para no depender de cuál haya quedado.
              usedIdsRef.current.clear();
              if (Array.isArray(ultjsnParsed?.paletsEnProceso)) {
                paletsRestaurados = ultjsnParsed.paletsEnProceso;
                paletsRestaurados.forEach((p) => {
                  usedIdsRef.current.add(p.idPalet);
                });
              } else if (Array.isArray(ultjsnParsed?.palets)) {
                // Aviso: queda un warn para ver en producción cada vez que
                // aparece esta forma. Si el backend empieza a guardar la
                // forma rica (la de pausar), este camino deja de ejecutarse.

                paletsRestaurados = ultjsnParsed.palets.map((p, i) => {
                  const articulos = Array.isArray(p?.articulos)
                    ? p.articulos
                    : [];
                  const articulo = articulos[0] ?? null;
                  const idartl = articulo?.idartl ?? null;

                  // El payload ahora trae sku/nombre/nropar, pero si el
                  // ultjsn se guardó antes del enriquecimiento hay que
                  // cruzarlos con los detalles del backend por idartl.
                  const detalle = (response.data.detalles || []).find(
                    (d) => idartl && d.idartl === idartl,
                  );

                  // Multiparte: el payload trae un artículo por parte.
                  const esMultiparte =
                    !!p?.esMultiparte || articulos.length > 1;

                  const partes = esMultiparte
                    ? articulos.map((a) => ({
                        idartl: a?.idartl ?? null,
                        idartp: a?.idartp ?? null,
                        nropar: a?.nropar ?? null,
                        sku: a?.sku ?? "",
                        nombre: a?.nombre ?? "",
                        lote: a?.lote ?? null,
                        vto: a?.vto ?? null,
                        cantidad: Number(a?.cantidad ?? 0),
                        voltotUnitario: Number(a?.voltotUnitario ?? 0),
                      }))
                    : null;

                  const asignado = Number(articulo?.cantid ?? 0);

                  return {
                    idPalet: p?.alias,
                    idartl,
                    idartp: articulo?.idartp ?? null,
                    nropar: articulo?.nropar ?? detalle?.nropar ?? null,
                    sku: articulo?.sku || detalle?.sku || "",
                    nombre: articulo?.nombre || detalle?.nombre || "",
                    lote: p?.lote ?? articulo?.lote ?? null,
                    vto: p?.vto ?? articulo?.vto ?? null,
                    esPaletLote: !!p?.esPaletLote,
                    cb1: p?.cb1 ?? null,
                    cb2: p?.cb2 ?? null,
                    cb3: p?.cb3 ?? null,
                    idpalt: p?.tipo ?? null,
                    idpala: p?.altura ?? null,
                    altura: p?.altura ?? null,
                    tipo: p?.tipo ?? null,
                    skupalet: p?.skupalet ?? null,
                    multiplo: p?.multiplo ?? null,
                    multiploAplicado: p?.multiploAplicado ?? null,
                    skusPermitidos: p?.skusPermitidos ?? null,
                    asignadoPorParte: p?.asignadoPorParte ?? null,
                    esMultiparte,
                    partes,
                    asignado,
                    // ctdPorPalet real si vino; si no, se cae a lo asignado.
                    ctdPorPalet: Number(p?.ctdPorPalet || asignado),
                    pendienteTotal: Number(p?.ctdPorPalet || asignado),
                    paletNumero: p?.paletNumero ?? i + 1,
                  };
                });

                paletsRestaurados.forEach((p) => {
                  if (p.idPalet) usedIdsRef.current.add(p.idPalet);
                });
              }

              // La forma de completar trae el granel ya contabilizado. Si vino
              // así y no hay detalles para restaurar, se reconstruye desde ahí.
              if (
                detallesFinales.length === 0 &&
                Array.isArray(ultjsnParsed?.granel)
              ) {
                const ajustados = (response.data.detalles || []).map((d) => ({
                  ...d,
                }));

                // Un mismo idartl puede traer varias filas de granel cuando hay
                // lotes distintos. Con lote se puede elegir la fila correcta;
                // sin él (ultjsn viejo) se cae al primero que coincida.
                const buscarFila = (ajustados, g) => {
                  const idartl = String(g?.idartl ?? "").trim();
                  const lote = String(g?.lote ?? "").trim();

                  if (lote) {
                    const porLote = ajustados.find(
                      (d) =>
                        String(d.idartl ?? "").trim() === idartl &&
                        String(d.lote ?? "").trim() === lote,
                    );
                    if (porLote) return porLote;
                  }

                  return ajustados.find(
                    (d) => String(d.idartl ?? "").trim() === idartl,
                  );
                };

                ultjsnParsed.granel.forEach((g) => {
                  const destino = buscarFila(ajustados, g);

                  if (destino) {
                    destino.ctdaud = Number(g?.cantid ?? 0);
                    if (g?.lote) destino.lote = g.lote;
                    if (g?.vto) destino.vto = g.vto;
                  }
                });

                detallesFinales = ajustados;
              }

              if (Array.isArray(ultjsnParsed?.paletsMultiarticulo)) {
                paletsMultiRestaurados = ultjsnParsed.paletsMultiarticulo;
              }

              // Revisar si hay configs perduradas
              if (Array.isArray(ultjsnParsed?.configs)) {
                setConfigs(ultjsnParsed.configs);
              } else {
                setConfigs([]); // reset si no hay
              }
            } catch (parseError) {
              console.warn(
                "Error parsing ultjsn, usando detalles originales",
                parseError,
              );
            }
          }

          if (detallesFinales.length === 0) {
            // no había ultjsn, estaba vacío o no traía detalles
            detallesFinales = response.data.detalles || [];
          }

          const inicial = detallesFinales.map((d) => ({
            ...d,
            ctdaud: d.ctdaud ?? 0,
            cantid: Number(d.cantid ?? 0),
            sku: String(d.sku ?? "").trim(),
          }));

          setDetallesLocal(inicial);
          detallesRef.current = inicial;
          setPaletsEnProceso(paletsRestaurados);
          setPaletsMultiarticulo(paletsMultiRestaurados);
          actualizarEstadoInicial(inicial);

          // DEBUG: con qué quedó la pantalla. Comparar contra el diagnóstico
          // de arriba para ver si el restore recovering algo.
        } else {
          setAuditoriaSMA(null);
          setDetallesLocal([]);
          setPaletsEnProceso([]);
          detallesRef.current = [];
          setEstadoInicial([]);
        }

        const responseDataPalets = await GETTiposPalet();
        if (responseDataPalets && responseDataPalets.status === 200) {
          setTiposPalet(responseDataPalets.data?.tiposPalet || []);
          setAlturasPalet(responseDataPalets.data?.alturasPalet || []);
        }
      } catch (err) {
        console.error(err);
        setAuditoriaSMA(null);
        setDetallesLocal([]);
        setPaletsEnProceso([]);
        detallesRef.current = [];
        setEstadoInicial([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [idauds, loggedUser]);

  const handleConfirmarLoteVtoGranel = async () => {
    setActiveTab("granel");

    const item = codigoPendienteRef.current;
    if (!item) return;

    const loteFinal = loteInput;
    const vtoFinal = vtoInput;

    if (!loteFinal || !vtoFinal) {
      message.error("Debe ingresar lote y fecha de vencimiento.");
      return;
    }

    try {
      const resp = await GETVerificarLoteVto(loteFinal, item.idartl, vtoFinal);

      if (resp.data?.codres === "1" && resp?.data?.result === "false") {
        message.error(resp.data.descri || "Error validando lote.");
        return;
      }

      let creoFilaNueva = false;

      setDetallesLocal((prev) => {
        const existe = prev.find(
          (it) =>
            it.sku === item.sku &&
            (it.nropar ?? "") === (item.nropar ?? "") &&
            (it.lote ?? "") === (loteFinal ?? "") &&
            String(it.vto ?? "").replaceAll("-", "") ===
              String(vtoFinal ?? "").replaceAll("-", ""),
        );

        if (existe) {
          return prev.map((it) => {
            if (
              it.sku === item.sku &&
              (it.nropar ?? "") === (item.nropar ?? "") &&
              (it.lote ?? "") === (loteFinal ?? "") &&
              String(it.vto ?? "").replaceAll("-", "") ===
                String(vtoFinal ?? "").replaceAll("-", "")
            ) {
              return {
                ...it,
                ctdaud: Number(it.ctdaud || 0) + 1,
                idartp: resp.data?.idartp ?? it?.idartp,
                idartf: resp.data?.idartf ?? it?.idartf,
              };
            }
            return it;
          });
        }

        creoFilaNueva = true;
        return [
          ...prev,
          {
            ...item,
            ctdaud: 1,
            idartp: resp.data?.idartp ?? item.idartp,
            idartf: resp.data?.idartf ?? item?.idartf,
            lote: loteFinal,
            vto: vtoFinal,
          },
        ];
      });

      // Al crear un nuevo lote/vto a granel, se activa automáticamente (play).
      // Al incrementar uno existente, no se activa por sí solo (así se pueden
      // dejar todos pausados).
      if (creoFilaNueva) {
        setLoteVtoActivo({
          sku: item.sku,
          nropar: item.nropar,
          lote: loteFinal,
          vto: vtoFinal,
        });
      }

      setModalLoteVisible(false);
      setLoteInput("");
      setVtoInput("");

      // message.success(resp?.data?.descri || "Lote verificado correctamente.");
    } catch (err) {
      message.error("Error llamando a verificación de lote.");
    }
  };

  const handleConfirmarProcesarLoteVto = async (loteOverride, vtoOverride) => {
    const item = codigoPendienteRef.current;
    if (!item) return;

    const loteActivo = loteVtoActivoRef.current;

    // El pin puede pertenecer al palet multi activo O al palet simple activo.
    // En ambos casos la lectura siguiente usa el lote/vto del pin sin volver
    // a pedirlos (play/pause).
    const hayLoteVtoActivoCompatible =
      loteActivo &&
      ((paletMultiActivoRef.current &&
        loteActivo.idPalet === paletMultiActivoRef.current) ||
        (paletActivoIdRef.current &&
          loteActivo.idPalet === paletActivoIdRef.current)) &&
      loteActivo.sku === item.sku &&
      (loteActivo.nropar ?? "") === (item.nropar ?? "");

    const loteFinal = hayLoteVtoActivoCompatible
      ? loteActivo.lote
      : loteOverride || loteInput;
    const vtoFinal = hayLoteVtoActivoCompatible
      ? loteActivo.vto
      : vtoOverride || vtoInput;

    if (!loteFinal || !vtoFinal) {
      message.error("Debe ingresar lote y fecha de vencimiento.");
      return;
    }

    try {
      const resp = await GETVerificarLoteVto(loteFinal, item.idartl, vtoFinal);

      if (resp.data?.codres === "1" && resp?.data?.result === "false") {
        message.error(resp.data.descri || "Error validando lote.");
        return;
      }

      let palet = null;

      if (paletActivoIdRef.current) {
        palet = paletsEnProceso.find(
          (p) => p.idPalet === paletActivoIdRef.current,
        );
      }

      if (!palet && paletMultiActivoRef.current) {
        palet = paletsMultiarticuloRef.current.find(
          (p) => p.idPalet === paletMultiActivoRef.current,
        );
      }

      if (!palet) {
        message.error("No se encontró el palet activo.");
        return;
      }

      if (!palet.esMultiarticulo) {
        const idartpFinal = resp?.data?.idartp ?? item.idartp ?? null;
        const idartfFinal = resp?.data?.idartf ?? item.idartf ?? null;

        const tieneLoteYvto = palet.lote && palet.vto;

        setPaletsEnProceso((prev) =>
          prev.map((p) => {
            if (p.idPalet !== palet.idPalet) return p;

            if (tieneLoteYvto) {
              if (p.lote !== loteFinal || p.vto !== vtoFinal) {
                return p;
              }

              return {
                ...p,
                meta: {
                  ...(p.meta || {}),
                  idartp: idartpFinal,
                  idartf: idartfFinal,
                },
                asignado: Number(p.asignado || 0) + 1,
              };
            }

            return {
              ...p,
              lote: loteFinal,
              vto: vtoFinal,
              meta: {
                ...(p.meta || {}),
                idartp: idartpFinal,
                idartf: idartfFinal,
              },
              asignado: Number(p.asignado || 0) + 1,
            };
          }),
        );

        if (
          tieneLoteYvto &&
          (palet.lote !== loteFinal || palet.vto !== vtoFinal)
        ) {
          message.error("El lote/vto no coincide con el asignado previamente.");
          return;
        }
      } else {
        setPaletsMultiarticulo((prev) => {
          const paletIndex = prev.findIndex(
            (p) => p.idPalet === paletMultiActivoRef.current,
          );
          if (paletIndex === -1) return prev;

          const paletActual = prev[paletIndex];
          const articulos = [...(paletActual.articulos || [])];

          const articuloIndex = articulos.findIndex(
            (a) =>
              a.sku === item.sku &&
              (a.nropar ?? "") === (item.nropar ?? "") &&
              a.lote === loteFinal &&
              a.vto === vtoFinal,
          );

          if (articuloIndex >= 0) {
            articulos[articuloIndex] = {
              ...articulos[articuloIndex],
              cantidad: Number(articulos[articuloIndex].cantidad || 0) + 1,
            };
          } else {
            articulos.push({
              idartp: resp.data.idartp ?? null,
              idartl: resp.data.idartl ?? null,
              idartf: resp.data.idartf ?? null,
              nropar: item.nropar ?? "",
              sku: item.sku,
              nombre: item.nombre,
              cantid: item.cantid,
              cantidad: 1,
              voltotUnitario: item.voltotUnitario ?? 0,
              lote: loteFinal,
              vto: vtoFinal,
            });
          }

          let volumenOcupadoM3 = 0;
          let asignadoTotal = 0;

          for (const art of articulos) {
            volumenOcupadoM3 +=
              Number(art.cantidad || 0) * Number(art.voltotUnitario || 0);
            asignadoTotal += Number(art.cantidad || 0);
          }

          const nuevosPalets = [...prev];
          nuevosPalets[paletIndex] = {
            ...paletActual,
            articulos,
            asignadoTotal,
            volumenOcupadoM3,
          };

          return nuevosPalets;
        });

        setDetallesLocal((prev) =>
          prev.map((it) => {
            if (
              it.sku === item.sku &&
              (it.nropar ?? "") === (item.nropar ?? "")
            ) {
              return {
                ...it,
                asignado: Number(it.cantidad || 0) + 1,
              };
            }
            return it;
          }),
        );
      }

      // El play/pause es solo de los palets personalizados (multi): en los
      // palets clásicos (mono artículo) no participa — el propio palet ya
      // identifica el artículo — así que no se deja ningún pin colgado.
      if (palet.esMultiarticulo) {
        setLoteVtoActivo({
          idPalet: palet.idPalet,
          sku: item.sku,
          nropar: item.nropar ?? "",
          lote: loteFinal,
          vto: vtoFinal,
        });
      }

      setModalLoteVisible(false);
      setLoteInput("");
      setVtoInput("");

      // message.success(resp?.data?.descri || "Lote verificado correctamente.");
    } catch (err) {
      message.error("Error llamando a verificación de lote.");
    }
  };

  const confirmarLoteVtoVLX = (itemSeleccionado) => {
    setDetallesLocal((prev) => {
      const idartlSeleccionado = String(itemSeleccionado.idartl ?? "").trim();
      const skuSeleccionado = String(itemSeleccionado.sku ?? "").trim();

      const copia = prev.map((item) => ({ ...item }));

      const index = copia.findIndex(
        (item) =>
          String(item.idartl ?? "").trim() === idartlSeleccionado &&
          String(item.sku ?? "").trim() === skuSeleccionado &&
          String(item.lote ?? "").trim() ===
            String(itemSeleccionado.lote ?? "").trim() &&
          String(item.vto ?? "").replaceAll("-", "") ===
            String(itemSeleccionado.vto ?? "").replaceAll("-", ""),
      );

      if (index === -1) {
        message.error("No se encontró el artículo seleccionado.");
        return prev;
      }

      copia[index].ctdaud = Number(copia[index].ctdaud || 0) + 1;

      detallesRef.current = copia;

      return copia;
    });

    // Sin pin automático: escanear a granel nunca deja un lote/vto "activo"
    // (play/pause). El pin solo se activa cuando el operador toca "play".

    setModalLoteVtoVLX({
      open: false,
      items: [],
      ubicacionActual: null,
      sku: null,
    });

    scrollToItem(itemSeleccionado);
  };

  const handleProcesamientoVLX = async (codigo) => {
    const response = await GETCodigoBarra(codigo, null, false, false);

    if (response.data?.idtipa !== "04") {
      if (String(response.data?.idtipa).trim() === "01") {
        const idartlBuscado = String(response.data?.idartl ?? "").trim();
        const itemGranel = detallesRef.current?.find(
          (d) => String(d.idartl ?? "").trim() === idartlBuscado,
        );
        if (itemGranel) scrollToItem(itemGranel);

        setDetallesLocal((prev) => {
          const copia = prev.map((item) => ({ ...item }));
          const index = copia.findIndex(
            (item) => String(item.idartl ?? "").trim() === idartlBuscado,
          );
          if (index === -1) {
            message.error("El artículo no corresponde a la auditoría.");
            return prev;
          }
          copia[index].ctdaud = Number(copia[index].ctdaud || 0) + 1;
          detallesRef.current = copia;
          return copia;
        });

        return true;
      }
      return false;
    }

    // ▼▼▼ NUEVO — selección de SKU cuando el GTIN resuelve a más de un artículo ▼▼▼
    const opcionesSku = parseDetart(response.data?.detart);

    if (opcionesSku.length > 1) {
      // Solo las opciones que pertenecen a esta auditoría: si un artículo de
      // detart no está entre los idartl de la auditoría, no se ofrece elegirlo.
      const idartlsAuditoria = new Set(
        detallesRef.current.map((d) => String(d.idartl ?? "").trim()),
      );
      const opcionesValidas = opcionesSku.filter((o) =>
        idartlsAuditoria.has(String(o.idartl ?? "").trim()),
      );

      // Si hay PLAY fijando un artículo que está entre las opciones → va directo.
      // Un pin con idPalet solo manda si ese palet sigue activo: si el palet se
      // eliminó o se cambió el activo, no debe seguir eligiendo el artículo.
      const pin = loteVtoActivoRef.current;
      const pinPaletSigueActiva =
        !pin?.idPalet ||
        pin.idPalet === paletActivoIdRef.current ||
        pin.idPalet === paletMultiActivoRef.current;

      const opcionPorPlay =
        pin && pinPaletSigueActiva
          ? opcionesValidas.find((o) =>
              detallesRef.current.some(
                (d) =>
                  String(d.idartl ?? "").trim() ===
                    String(o.idartl ?? "").trim() &&
                  String(d.sku ?? "").trim() ===
                    String(pin.sku ?? "").trim(),
              ),
            )
          : null;

      // El palet activo (simple o multi) ya identifica el artículo: si su idartl
      // está entre las opciones se usa directo, sin preguntar cuál escanear.
      const paletMonoActivoDetart = paletActivoIdRef.current
        ? paletsEnProceso.find(
            (p) => p.idPalet === paletActivoIdRef.current && !p.esMultiparte,
          )
        : null;

      const idartlPaletActivo = String(
        paletMonoActivoDetart?.idartl ?? "",
      ).trim();

      const paletMultiActivoDetart = paletMultiActivoRef.current
        ? paletsMultiarticulo.find(
            (p) => p.idPalet === paletMultiActivoRef.current,
          )
        : null;

      const idartlsPaletMulti = (paletMultiActivoDetart?.articulos ?? [])
        .map((a) => String(a.idartl ?? "").trim())
        .filter(Boolean);

      const opcionPorPaletActivo = idartlPaletActivo
        ? opcionesValidas.find(
            (o) => String(o.idartl ?? "").trim() === idartlPaletActivo,
          )
        : idartlsPaletMulti.length > 0
          ? opcionesValidas.find((o) =>
              idartlsPaletMulti.includes(String(o.idartl ?? "").trim()),
            )
          : null;

      // En la pestaña "Palet" el palet activo manda sobre el pin: si el
      // operador armó/desarmó a granel y después paletiza, un pin de granel
      // no puede elegir un artículo distinto al del palet activo.
      if (activeTab === "palet" && opcionPorPaletActivo) {
        response.data.idartl = opcionPorPaletActivo.idartl;
      } else if (opcionPorPlay) {
        response.data.idartl = opcionPorPlay.idartl;
      } else if (opcionPorPaletActivo) {
        response.data.idartl = opcionPorPaletActivo.idartl;
      } else if (opcionesValidas.length === 1) {
        // Una sola que corresponda a la auditoría → se usa directo, sin modal
        response.data.idartl = opcionesValidas[0].idartl;
      } else if (opcionesValidas.length > 1) {
        const elegido = await esperarSeleccionSku(opcionesValidas);
        if (!elegido) return true; // canceló → no hace nada
        response.data.idartl = elegido.idartl;
      }
      // Si ninguna corresponde → no se toca nada, sigue el flujo normal
    }
    // ▲▲▲ FIN NUEVO ▲▲▲

    const idartlBuscado = String(response.data.idartl).trim();

    const lotesParaEseArticulo = detallesRef.current.filter(
      (d) => String(d.idartl).trim() === idartlBuscado,
    );

    if (lotesParaEseArticulo.length === 0) {
      message.error("El artículo no corresponde a la auditoría.");
      return true;
    }

    // Obtiene lote/vto desde los campos normales o desde valcar
    const obtenerLoteVto = (d) => {
      let lote = String(d.lote ?? "").trim();
      let vto = String(d.vto ?? "").trim();

      if ((!lote || !vto) && d.valcar) {
        const valcar = String(d.valcar);

        const loteMatch = valcar.match(/L:\s*([^\s]+)\s+V:/i);
        const vtoMatch = valcar.match(/V:\s*([^\s]+)/i);

        lote = lote || loteMatch?.[1]?.trim() || "";
        vto = vto || vtoMatch?.[1]?.trim() || "";
      }

      return { lote, vto };
    };

    // ▼▼▼ NUEVO — palet simple activo del artículo: el +1 va al palet ▼▼▼
    // En la pestaña "Palet" este bloque corre ANTES del pin de granel
    // (hayLoteActivoCompatible): si hay un palet simple activo del artículo
    // escaneado, el +1 va al palet; un pin de "play/pause" que haya quedado
    // de granel no puede redirigirlo a una fila de granel.
    const paletMonoActivoLlenado = paletActivoIdRef.current
      ? paletsEnProceso.find(
          (p) =>
            p.idPalet === paletActivoIdRef.current &&
            !p.esMultiparte &&
            !p.esPaletLote,
        )
      : null;

    const itemDelPalet = paletMonoActivoLlenado
      ? lotesParaEseArticulo.find((d) =>
          mismoArticuloQuePalet(d, paletMonoActivoLlenado),
        )
      : null;

    if (activeTab === "palet" && itemDelPalet) {
      const { lote: lotePaletTxt, vto: vtoPaletTxt } =
        paletMonoActivoLlenado;
      const { lote: loteFilaTxt, vto: vtoFilaTxt } =
        obtenerLoteVto(itemDelPalet);

      // El pin de granel define el lote/vto del palet SOLO si pertenece al
      // mismo artículo (mismo sku): con varios lote/vto el pin decide cuál
      // entra al palet en lugar de mandar el +1 a una fila de granel.
      const pinLoteVto = loteVtoActivoRef.current;
      const pinEsDelArticulo =
        pinLoteVto &&
        !pinLoteVto.idPalet &&
        lotesParaEseArticulo.some(
          (d) =>
            String(d.sku ?? "").trim() ===
            String(pinLoteVto.sku ?? "").trim(),
        );
      const lotePinTxt = pinEsDelArticulo
        ? String(pinLoteVto.lote ?? "").trim()
        : "";
      const vtoPinTxt = pinEsDelArticulo
        ? String(pinLoteVto.vto ?? "").trim()
        : "";

      const lotePaletFinal = lotePaletTxt || lotePinTxt || loteFilaTxt;
      const vtoPaletFinal = vtoPaletTxt || vtoPinTxt || vtoFilaTxt;

      // Con varios lote/vto del mismo artículo y sin pin que decida, no se
      // elige por el operador: se mantiene el flujo actual (ModalSeleccionVLX)
      const hayMultiLoteAmbiguo =
        !lotePaletTxt &&
        !lotePinTxt &&
        lotesParaEseArticulo.filter((d) => {
          const { lote, vto } = obtenerLoteVto(d);
          return lote && vto;
        }).length > 1;

      if (!hayMultiLoteAmbiguo) {
        codigoPendienteRef.current = itemDelPalet;

        if (lotePaletFinal && vtoPaletFinal) {
          await handleConfirmarProcesarLoteVto(
            lotePaletFinal,
            vtoPaletFinal,
          );
        } else {
          setModalLoteNombreArt(itemDelPalet.nombre);
          setModalLoteVisible(true);
        }

        return true;
      }
    }
    // ▲▲▲ FIN NUEVO ▲▲▲

    // PLAY/PAUSE: check si hay loteVtoActivo compatible
    const loteActivo = loteVtoActivoRef.current;

    const hayLoteActivoCompatible =
      loteActivo &&
      // Solo pins de granel (sin idPalet): un pin de palet llena el palet
      // (paletPinCompatible), nunca una fila de granel.
      !loteActivo.idPalet &&
      lotesParaEseArticulo.some((d) => {
        const { lote, vto } = obtenerLoteVto(d);

        return (
          d.sku === loteActivo.sku &&
          lote === String(loteActivo.lote ?? "").trim() &&
          vto.replaceAll("-", "") ===
            String(loteActivo.vto ?? "").replaceAll("-", "")
        );
      });

    if (hayLoteActivoCompatible) {
      const itemBuscado = lotesParaEseArticulo.find((d) => {
        const { lote, vto } = obtenerLoteVto(d);

        return (
          d.sku === loteActivo.sku &&
          lote === String(loteActivo.lote ?? "").trim() &&
          vto.replaceAll("-", "") ===
            String(loteActivo.vto ?? "").replaceAll("-", "")
        );
      });

      confirmarLoteVtoVLX(itemBuscado);

      return true;
    }

    // ▼▼▼ NUEVO — play/pause con lote/vto del palet activo (simple o multi) ▼▼▼
    // El pin (keyboard) guardó el lote/vto en el palet, no en una fila de
    // detalles: el +1 va directo al palet sin volver a abrir el modal.
    const itemParaPaletPin = loteActivo
      ? lotesParaEseArticulo.find(
          (d) =>
            String(d.sku ?? "").trim() ===
            String(loteActivo.sku ?? "").trim(),
        )
      : null;

    const paletPinCompatible =
      loteActivo &&
      loteActivo.idPalet &&
      ((paletActivoIdRef.current &&
        loteActivo.idPalet === paletActivoIdRef.current) ||
        (paletMultiActivoRef.current &&
          loteActivo.idPalet === paletMultiActivoRef.current)) &&
      !!itemParaPaletPin;

    if (paletPinCompatible) {
      codigoPendienteRef.current = itemParaPaletPin;
      await handleConfirmarProcesarLoteVto();
      return true;
    }
    // ▲▲▲ FIN NUEVO ▲▲▲

    // No hay lote activo: verificar si el item ya tiene lote/vto
    if (lotesParaEseArticulo.length === 1) {
      const item = lotesParaEseArticulo[0];
      const { lote, vto } = obtenerLoteVto(item);

      // AUTO CONFIRMA AL HABER SOLO UN LOTE
      if (lote && vto) {
        confirmarLoteVtoVLX(item);

        return true;
      }

      // Primera vez → abrir ModalLoteVto
      codigoPendienteRef.current = item;
      setModalLoteNombreArt(item.nombre);
      setModalLoteVisible(true);

      return true;
    }

    // Múltiples items para ese idartl
    const itemsConLote = lotesParaEseArticulo.filter((d) => {
      const { lote, vto } = obtenerLoteVto(d);

      return lote && vto;
    });

    if (esRecepcionMercaderia) {
      codigoPendienteRef.current = lotesParaEseArticulo[0];
      setModalLoteNombreArt(lotesParaEseArticulo[0].nombre);
      setModalLoteVisible(true);

      return true;
    }

    if (itemsConLote.length > 0) {
      // Hay items con lote/vto → ModalSeleccionVLX
      setModalLoteVtoVLX({
        open: true,
        items: itemsConLote,
        ubicacionActual: null,
        sku: codigo,
      });

      return true;
    }

    // Ninguno tiene lote/vto → ModalLoteVto con el primero
    codigoPendienteRef.current = lotesParaEseArticulo[0];
    setModalLoteNombreArt(lotesParaEseArticulo[0].nombre);
    setModalLoteVisible(true);
    return true;
  };

  const procesarCodigo = async (codigoRaw) => {
    if (paletLoteActivoRef.current) {
      return;
    }

    if (normalizeGS1Barcode(codigoRaw) && usaLote === "true") {
      setCodigoDetectado(codigoRaw);
      setActiveTab("palet");
      setTimeout(() => {
        setPaletLoteActivo(true);
      }, 500);
      return;
    }

    const codigo = String(codigoRaw || "").trim();

    if (usaLote === "true") {
      await handleProcesamientoVLX(codigo);
      return;
    }

    if (!codigo) {
      return;
    }

    scrollToItem(codigo);

    // ------------ Comportamiento palet multiartículo ------------
    if (paletMultiActivoRef.current) {
      const paletMulti = paletsMultiarticuloRef.current.find(
        (p) => p.idPalet === paletMultiActivoRef.current,
      );

      //! IF EAM13 LLAMAR ENDPOINT CODIGO| INVOCAR LA FUNCION SEGUN idArticulo si es 4************
      if (codigo === "3930020") {
        // if (codigo === "2359150") {
        const itemEscaneado = detallesLocal.current?.find(
          (i) => normalizarCodigo(i.codigo) === normalizarCodigo(codigo),
        );

        const loteActivo = loteVtoActivoRef.current;

        if (!itemEscaneado) {
          message.error("No se encontró el artículo escaneado.");
          return;
        }

        codigoPendienteRef.current = itemEscaneado;

        const hayLoteVtoActivoCompatible =
          loteActivo &&
          paletMultiActivoRef.current &&
          loteActivo.idPalet === paletMultiActivoRef.current &&
          loteActivo.sku === itemEscaneado.sku;

        if (hayLoteVtoActivoCompatible) {
          await handleConfirmarProcesarLoteVto();
        } else {
          setModalLoteNombreArt(itemEscaneado.nombre);
          setModalLoteVisible(true);
        }

        return;
      }

      if (!paletMulti) {
        setPaletMultiActivo(null);
        message.error("Palet multiartículo no encontrado.");
        return;
      }

      const item = detallesRef.current?.find(
        (i) => normalizarCodigo(i.codigo) === normalizarCodigo(codigo),
      );

      scrollToItem(item);

      if (!item) {
        message.error(
          "El código no corresponde a un artículo de la auditoría.",
        );
        return;
      }

      //  Verificar que no excedamos la cantidad disponible (cantid - ctdaud)
      const disponible = Number(item.cantid) - Number(item.ctdaud || 0);
      if (disponible <= 0) {
        message.warning("No hay unidades disponibles de este artículo.");
        return;
      }

      const voltotUnitario =
        item.ctdpar > 1 ? Number(item.volpar || 0) : Number(item.voltot || 0); // Si es una parte en si, usar volpar, sino voltot

      const volumenAdicional = voltotUnitario;

      const nuevoVolumenOcupado =
        paletMulti.volumenOcupadoM3 + volumenAdicional;
      if (nuevoVolumenOcupado > paletMulti.capacidadVolM3) {
        message.error(
          "No hay suficiente espacio en el palet para agregar esta unidad.",
        );
        return;
      }

      // Actualizar el palet multiartículo
      setPaletsMultiarticulo((prev) => {
        const paletIndex = prev.findIndex(
          (p) => p.idPalet === paletMultiActivoRef.current,
        );

        if (paletIndex === -1) return prev;
        const palet = prev[paletIndex];
        const articulos = [...palet.articulos];
        const articuloIndex = articulos.findIndex(
          (art) => art.sku === item.sku && art.nropar === item.nropar,
        );
        if (articuloIndex >= 0) {
          articulos[articuloIndex] = {
            ...articulos[articuloIndex],
            cantidad: articulos[articuloIndex].cantidad + 1,
          };
        } else {
          articulos.push({
            idartp: item.idartp,
            nropar: item.nropar ?? "",
            sku: String(item.sku || "").trim(),
            nombre: String(item.nombre || "Sin nombre").trim(),
            cantid: item.cantid,
            cantidad: 1,
            voltotUnitario:
              item.ctdpar > 1
                ? Number(item.volpar || 0)
                : Number(item.voltot || 0),
            // Aca tambien, asi unifico el calculo y el objeto articulo ya viaja con su volumen total siendo (volpar o voltot)
          });
        }

        let volumenOcupadoM3 = 0;
        let asignadoTotal = 0;
        for (const art of articulos) {
          volumenOcupadoM3 += art.cantidad * art.voltotUnitario;
          asignadoTotal += art.cantidad;
        }

        const nuevosPalets = [...prev];
        nuevosPalets[paletIndex] = {
          ...palet,
          articulos,
          volumenOcupadoM3,
          asignadoTotal,
        };
        return nuevosPalets;
      });

      // Actualizar ctdaud en detallesLocal (¡esto era lo que faltaba!)
      setDetallesLocal((prev) =>
        prev.map((it) => {
          if (it.sku === item.sku && it.nropar === item.nropar) {
            return {
              ...it,
              // ctdaud: Number(it.ctdaud || 0) + 1,
            };
          }
          return it;
        }),
      );

      return;
    }

    // ------------ Comportamiento palet y con palets en proceso ------------
    if (activeTab === "palet" && paletsEnProceso.length > 0) {
      // Encontrar el artículo escaneado
      const itemEscaneado = detallesRef.current?.find(
        (i) => normalizarCodigo(i.codigo) === normalizarCodigo(codigo),
      );

      if (!itemEscaneado) {
        message.error("Código no encontrado.");
        return;
      }

      scrollToItem(itemEscaneado);

      const paletActivo = paletsEnProceso.find(
        (p) => p.idPalet === paletActivoIdRef.current,
      );

      if (!paletActivo) {
        message.error("No hay palet activo.");
        return;
      }

      if (paletActivo.asignado >= paletActivo.ctdPorPalet) {
        message.error("El palet activo está completo.");
        return;
      }

      const esCompatible =
        Number(itemEscaneado.ctdpar) > 1
          ? paletActivo.idartf === itemEscaneado.idartf
          : paletActivo.sku === itemEscaneado.sku;

      //! IF EAM13 LLAMAR ENDPOINT CODIGO| INVOCAR LA FUNCION SEGUN idArticulo si es 4************

      if (codigo === "2359150") {
        // if (codigo === "2359150") {
        let palet = null;

        if (paletActivoIdRef.current) {
          palet = paletsEnProceso.find(
            (p) => p.idPalet === paletActivoIdRef.current,
          );
        }

        if (palet && !palet.esMultiarticulo) {
          const tieneLote = palet.lote;
          const tieneVto = palet.vto;

          if (tieneLote && tieneVto && palet.sku === codigo) {
            palet.asignado += 1;

            setPaletsEnProceso([...paletsEnProceso]);

            return;
          }
        }

        codigoPendienteRef.current = itemEscaneado;
        setModalLoteNombreArt(itemEscaneado.nombre);
        setModalLoteVisible(true);
        return;
      }

      if (!esCompatible) {
        message.error("El palet activo no corresponde a este artículo.");
        return;
      }

      // Actualizar el palet
      const nuevosPalets = [...paletsEnProceso];

      const index = nuevosPalets.findIndex(
        (p) => p.idPalet === paletActivo.idPalet,
      );

      if (index === -1) return;

      const paletActualizado = { ...nuevosPalets[index] };

      const asignadoPorParte = {};
      if (paletActivo.esMultiparte) {
        const nuevoAsignadoPorParte = { ...paletActualizado.asignadoPorParte };
        nuevoAsignadoPorParte[itemEscaneado.idartp] =
          (nuevoAsignadoPorParte[itemEscaneado.idartp] || 0) + 1;

        const nuevoAsignado = Math.min(...Object.values(nuevoAsignadoPorParte));

        paletActualizado.asignadoPorParte = nuevoAsignadoPorParte;
        paletActualizado.asignado = nuevoAsignado;

        // Cuando creo el palet siguiente, inicializo asignadoPorParte de esta manera siempre espera la lectura de todas las piezas por igual
        paletActualizado.partes.forEach((parte) => {
          asignadoPorParte[parte.idartp] = 0;
        });
      } else {
        paletActualizado.asignado += 1;
      }

      nuevosPalets[index] = paletActualizado;

      // ---------- POST-CIERRE DE PALET ----------
      const itemOriginal = detallesRef.current?.find(
        (item) =>
          item.idartp === paletActualizado.idartp &&
          item.nropar === paletActualizado.nropar,
      );

      if (itemOriginal) {
        const cantidTotal = Number(itemOriginal.cantid ?? 0);
        const ctdaudGranel = Number(itemOriginal.ctdaud ?? 0);

        const totalAsignadoEnPalets = nuevosPalets
          .filter(
            (p) =>
              p.idartp === paletActualizado.idartp &&
              p.nropar === paletActualizado.nropar,
          )
          .reduce((sum, p) => sum + p.asignado, 0);

        const pendienteRestante =
          cantidTotal - (totalAsignadoEnPalets + ctdaudGranel);

        const paletLleno =
          paletActualizado.asignado === paletActualizado.ctdPorPalet;

        if (paletLleno && pendienteRestante > 0) {
          const ctdPorPaletNueva = calcularCapacidadPalet(
            itemOriginal,
            paletActualizado.idpalt,
            paletActualizado.idpala,
            tiposPalet,
            alturasPalet,
            pendienteRestante,
            paletActualizado.ctdPorPalet,
          );

          const nuevoPalet = {
            idPalet: generarIdPaletUnico(),
            idartl: paletActualizado.idartl,
            idartp: paletActualizado.idartp,
            idartf: paletActualizado.idartf,
            nropar: paletActualizado.nropar,
            sku: paletActualizado.sku,
            nombre: paletActualizado.nombre,
            idpalt: paletActualizado.idpalt,
            idpala: paletActualizado.idpala,
            cantid: itemOriginal.cantid,
            ctdaud: itemOriginal.ctdaud,
            pendienteTotal: pendienteRestante,
            asignado: 0,
            asignadoPorParte,
            paletNumero: nuevosPalets.length + 1,
            ctdPorPalet: ctdPorPaletNueva,
            esMultiparte: paletActualizado.esMultiparte,
            partes: paletActualizado.partes,
            skusPermitidos: paletActualizado.skusPermitidos,
          };

          setPaletsEnProceso([nuevoPalet, ...nuevosPalets]);
          setTimeout(() => setPaletActivoId(nuevoPalet.idPalet), 0);
          return;
        }
      }

      setPaletsEnProceso(nuevosPalets);
      return;
    }

    // ------------ Comportamiento original para "Granel" ------------

    let index;

    index = detallesRef.current.findIndex(
      (i) => String(i.codigo).trim() === codigo,
    );

    if (index === -1) {
      const response = await GETCodigoBarra(codigo, null, false, false);

      if (response && response?.data.status === 400) {
        message.error(
          response?.data.message || "No se pudo consultar el código de barra.",
        );
        return;
      } else {
        // Obtenemos idartl del response
        const responseIdartl = response?.data?.idartl;
        if (!responseIdartl) {
          message.error(
            "El código no corresponde a un artículo de la auditoría.",
          );
          return;
        }

        // Buscamos en detallesLocal usando idartl
        index = detallesRef.current.findIndex(
          (i) => String(i.idartl).trim() === String(responseIdartl).trim(),
        );

        if (index === -1) {
          message.error(
            "El artículo no corresponde a un artículo de la auditoría.",
          );
          return;
        }
      }
    }

    const item = detallesRef.current[index];

    if (!item.idartf || !item.idartp) {
      const loteActivo = loteVtoActivoRef.current;

      const hayLoteActivoCompatible =
        loteActivo &&
        loteActivo.sku === item.sku &&
        (loteActivo.nropar ?? "") === (item.nropar ?? "");

      if (hayLoteActivoCompatible) {
        setDetallesLocal((prev) =>
          prev.map((it) => {
            const matchExacto =
              it.sku === item.sku &&
              (it.nropar ?? "") === (item.nropar ?? "") &&
              (it.lote ?? "") === (loteActivo.lote ?? "") &&
              String(it.vto ?? "").replaceAll("-", "") ===
                String(loteActivo.vto ?? "").replaceAll("-", "");

            if (matchExacto) {
              return {
                ...it,
                ctdaud: Number(it.ctdaud || 0) + 1,
              };
            }

            return it;
          }),
        );

        return;
      }

      codigoPendienteRef.current = item;
      setModalLoteNombreArt(item.nombre);

      setModalLoteVisible(true);
      return;
    }

    scrollToItem(item);

    setDetallesLocal((prev) => {
      const copia = prev.map((it) => ({ ...it }));
      copia[index].ctdaud = Number(copia[index].ctdaud ?? 0) + 1;
      detallesRef.current = copia;
      return copia;
    });
  };

  const scrollToItem = (item) => {
    const el = document.getElementById(getItemDomId(item));

    if (!el || !scrollContainerRef.current) return;

    // Calcular posición relativa al contenedor scrollable
    const containerRect = scrollContainerRef.current.getBoundingClientRect();
    const elementRect = el.getBoundingClientRect();
    const scrollTop = scrollContainerRef.current.scrollTop;
    const offsetTop = elementRect.top - containerRect.top + scrollTop;

    scrollContainerRef.current.scrollTo({
      top: offsetTop - containerRect.height / 2 + el.offsetHeight / 2, // centrado
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!ordenActiva) return;
      const tag = (e.target && e.target.tagName) || "";
      if (tag === "INPUT" || tag === "TEXTAREA" || e.isComposing) return;
      if (e.key === "Enter") {
        const toProcess = bufferRef.current;
        bufferRef.current = "";
        procesarCodigo(toProcess);
        return;
      }
      if (e.key === "Backspace") {
        bufferRef.current = bufferRef.current.slice(0, -1);
        return;
      }
      if (e.key.length === 1) {
        bufferRef.current += e.key;
        return;
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [ordenActiva, activeTab, paletsEnProceso, detallesLocal]);

  // Desactiva automáticamente el palet si ya no tiene pendiente
  useEffect(() => {
    if (paletActivoId) {
      const paletActivo = paletsEnProceso.find(
        (p) => p.idPalet === paletActivoIdRef.current,
      );

      if (paletActivo) {
        if (
          !tienePendientePaletizable(
            paletsEnProceso,
            detallesLocal,
            paletActivo,
          )
        ) {
          setPaletActivoId(null); // Deja de estar activo
        }
      } else {
        setPaletActivoId(null);
      }
    }
  }, [paletsEnProceso, detallesLocal, paletActivoId]);

  const handleCompletarAuditoriaSMA = async () => {
    // El idartl viaja siempre: los artículos granel llegan del backend con
    // idartp en null (LEFT JOIN artpar), así que mandando solo idartp el backend
    // recibía palets sin artículo identificable. Si viene null no molesta.
    //
    // lote/vto/valcar se agregan porque el backend guarda este payload como
    // ultjsn, y sin ellos un mismo idartl con dos lotes distintos queda con dos
    // entradas indistinguibles al restaurar. Son claves nuevas: el contrato
    // previo (idartl, idartp, cantid) queda intacto.
    const granel = detallesLocal
      .filter((item) => item.ctdaud > 0)
      .map((item) => ({
        idartl: item.idartl,
        idartp: item.idartp,
        cantid: Number(item.ctdaud || 0),
        lote: item.lote ?? null,
        vto: item.vto ?? null,
        valcar: item.valcar ?? null,
        sku: item.sku ?? "",
        nombre: item.nombre ?? "",
        nropar: item.nropar ?? null,
      }));

    // El base es el que ya se mandaba: alias/altura/tipo/cb1-3. Se le suma
    // el estado del palet que solo vive en memoria (lote, vto, capacidad,
    // multiparte, multiplo) para que el ultjsn que guarda el backend permita
    // restaurar la pantalla tal como estaba. Todo aditivo: ninguna clave previa
    // se renombra ni se saca, y la forma de articulos[] sigue siendo la misma
    // más campos extra.

    const paletsSimples = paletsEnProceso
      .filter((p) => (p.asignado || 0) > 0)
      .map((palet) => {
        const articulo = palet.articulos?.[0] || palet.articulo || null;

        const lote = articulo?.lote ?? null;
        const vto = articulo?.vto ?? null;
        const base = {
          alias: palet.idPalet,
          altura: palet.idpala,
          tipo: palet.idpalt,
          ...(palet.cb1 && { cb1: String(palet.cb1) }),
          ...(palet.cb2 && { cb2: String(palet.cb2) }),
          ...(palet.cb3 && { cb3: String(palet.cb3) }),

          lote,
          vto,
          esPaletLote: !!palet.esPaletLote,
          ctdPorPalet: Number(palet.ctdPorPalet || 0),
          paletNumero: palet.paletNumero ?? null,
          skupalet: palet.skupalet ?? null,
          multiplo: palet.multiplo ?? null,
          multiploAplicado: palet.multiploAplicado ?? null,
          skusPermitidos: palet.skusPermitidos ?? null,
          asignadoPorParte: palet.asignadoPorParte ?? null,
          esMultiparte: !!palet.esMultiparte,
          partes: palet.esMultiparte ? (palet.partes ?? null) : null,
        };

        // MULTIPARTE
        if (palet.esMultiparte) {
          return {
            ...base,
            articulos: palet.partes.map((parte) => ({
              idartl: parte.idartl ?? palet.idartl,
              idartp: parte.idartp,
              idartf: parte.idartf,
              cantid: Number(palet.asignado),
              nropar: parte.nropar ?? null,
              sku: parte.sku ?? "",
              nombre: parte.nombre ?? "",
              lote: parte.lote ?? null,
              vto: parte.vto ?? null,
              cantidad: Number(parte.cantidad ?? 0),
              voltotUnitario: Number(parte.voltotUnitario ?? 0),
            })),
          };
        }

        // SIMPLE
        const idartl =
          palet.meta?.idartl || palet.idartl || palet.articulo?.idartl || null;

        const idartp =
          palet.meta?.idartp || palet.idartp || palet.articulo?.idartp || null;

        const idartf =
          palet.meta?.idartf || palet.idartf || palet.articulo?.idartf || null;

        return {
          ...base,
          articulos: [
            {
              idartl,
              idartp,
              idartf,
              cantid: Number(palet.asignado),
              lote: palet.lote ?? null,
              vto: palet.vto ?? null,
              sku: palet.sku ?? "",
              nombre: palet.nombre ?? "",
              nropar: palet.nropar ?? null,
            },
          ],
        };
      });

    // Mismo criterio que paletsSimples: aditivo sobre el base previo.
    // Este tipo de palet usa altura/tipo (no idpala/idpalt), se respeta.
    const paletsMulti = paletsMultiarticulo.map((p) => {
      const articulo = p.articulos?.[0] ?? null;

      const lote = articulo?.lote ?? null;
      const vto = articulo?.vto ?? null;

      return {
        alias: p.idPalet,
        altura: p.altura,
        tipo: p.tipo,

        ...(p.cb1 && { cb1: String(p.cb1) }),
        ...(p.cb2 && { cb2: String(p.cb2) }),
        ...(p.cb3 && { cb3: String(p.cb3) }),

        // El lote/vto del PALET salen de su artículo
        lote,
        vto,

        esPaletLote: !!p.esPaletLote,
        ctdPorPalet: Number(p.ctdPorPalet || 0),
        paletNumero: p.paletNumero ?? null,

        articulos: p.articulos.map((a) => ({
          idartl: a.idartl,
          idartp: a.idartp,
          idartf: a.idartf,
          cantid: Number(p.asignado || a.cantidad || 0),

          nropar: a.nropar ?? null,
          sku: a.sku ?? "",
          nombre: a.nombre ?? "",

          // El artículo conserva sus propios datos
          lote: a.lote ?? null,
          vto: a.vto ?? null,

          cantidad: Number(a.cantidad || 0),
          voltotUnitario: Number(a.voltotUnitario ?? 0),
        })),
      };
    });

    const payload = {
      id: auditoriaSMA?.id || idauds,
      granel,
      palets: [...paletsSimples, ...paletsMulti],
      configs: configs.map((config) => {
        return {
          idartl: config?.idartl,
          idpalt: config?.idpalt,
          idpala: config?.idpala,
          capacidad: config?.capacidad,
        };
      }),
    };

    const response = await PUTCompletarAuditoriaSMA(payload, loggedUser);

    if (response && response.status === 200) {
      if (response?.data?.codres === 0) {
        // message.success(response?.data?.descri || "OK");
        setModalDiferencias({ open: false, descri: "", diferencias: [] });
        setAuditoriaCompletada(true);
        actualizarEstadoInicial(detallesLocal);
        navigate(-1);
      } else {
        const descri = response?.data?.descri || "Ocurrió un error.";
        const diferencias = parseDiferenciasSMA(response?.data?.difjsn);

        // Si vino el detalle de diferencias se muestra en modal, que informa
        // mucho más que el toast. Si no, sigue el mensaje de antes.
        if (diferencias.length > 0) {
          setModalDiferencias({ open: true, descri, diferencias });
        } else {
          message.error(descri);
        }
      }
    } else {
      message.error(response?.data?.message || "Ocurrió un error.");
    }
  };

  const handleConfirmModal = (itemActualizado) => {
    const { valorFinal, sku, parte, origen, idPalet, cantid, valcar } =
      itemActualizado;

    const nuevoValor = Number(valorFinal);

    // "Desarmar de granel": si se deja en 0 una fila de granel y el pin de
    // play/pause pertenece a esa misma fila, se limpia para que no quede
    // nada "linkeado" a granel al pasar a paletizar (un pin de granel no
    // debe decidir el artículo ni el lote de los escaneos que siguen).
    if (
      nuevoValor === 0 &&
      origen !== "palet" &&
      origen !== "multipalet"
    ) {
      const pinGranel = loteVtoActivoRef.current;
      if (pinGranel && !pinGranel.idPalet) {
        const norm = (v) => String(v ?? "").trim();
        const normVto = (v) => String(v ?? "").replaceAll("-", "").trim();
        const mismaFilaGranel =
          norm(pinGranel.sku) === norm(sku) &&
          norm(pinGranel.nropar) === norm(parte) &&
          norm(pinGranel.lote) === norm(itemActualizado?.lote) &&
          normVto(pinGranel.vto) === normVto(itemActualizado?.vto);

        if (mismaFilaGranel) {
          setLoteVtoActivo(null);
        }
      }
    }

    if (valcar) {
      setDetallesLocal((prev) => {
        const copia = prev.map((item) => ({ ...item }));

        const index = copia.findIndex(
          (item) =>
            String(item.valcar ?? "").trim() === String(valcar ?? "").trim(),
        );

        if (index === -1) {
          message.error("No se encontró el valcar seleccionado.");
          return prev;
        }

        copia[index].ctdaud = nuevoValor;

        detallesRef.current = copia;

        return copia;
      });

      setModalVisible({ status: false, payload: null });

      return;
    }

    if (origen === "palet" && idPalet) {
      if (isNaN(nuevoValor) || nuevoValor < 0) {
        message.error("Cantidad inválida.");
        setModalVisible({ status: false, payload: null });
        return;
      }

      const paletActual = paletsEnProceso.find((p) => p.idPalet === idPalet);

      if (!paletActual) {
        setModalVisible({ status: false, payload: null });
        return;
      }

      //  NUEVO: manejo para multipartes
      if (paletActual.esMultiparte) {
        // Validar que no exceda el límite del palet
        if (nuevoValor > paletActual.ctdPorPalet) {
          message.error(
            `La cantidad no puede superar ${paletActual.ctdPorPalet} unidades para este palet.`,
          );
          setModalVisible({ status: false, payload: null });
          return;
        }

        // Validar límite total del artículo
        const itemOriginal = detallesLocal.find(
          (item) =>
            item.idartp === itemActualizado.idartp &&
            item.nropar === itemActualizado.nropar,
        );
        if (itemOriginal) {
          const ctdaudGranel = Number(itemOriginal.ctdaud ?? 0);
          const totalAsignadoEnOtrosPalets = paletsEnProceso
            .filter(
              (p) =>
                p.idPalet !== idPalet &&
                p.idartp === itemActualizado.idartp &&
                p.nropar === itemActualizado.nropar,
            )
            .reduce(
              (sum, p) =>
                sum + (p.asignadoPorParte?.[itemActualizado.idartp] || 0),
              0,
            );

          const totalConNuevoValor =
            ctdaudGranel + totalAsignadoEnOtrosPalets + nuevoValor;
          if (totalConNuevoValor > Number(itemOriginal.cantid)) {
            message.error(
              "La cantidad supera el total pendiente del artículo.",
            );
            setModalVisible({ status: false, payload: null });
            return;
          }
        }

        // Actualizar asignadoPorParte
        setPaletsEnProceso((prevPalets) => {
          const paletIndex = prevPalets.findIndex((p) => p.idPalet === idPalet);
          if (paletIndex === -1) return prevPalets;

          const palet = prevPalets[paletIndex];
          const nuevoAsignadoPorParte = { ...palet.asignadoPorParte };
          nuevoAsignadoPorParte[itemActualizado.idartp] = nuevoValor;

          // Recalcular asignado como el mínimo
          const nuevoAsignado = Math.min(
            ...Object.values(nuevoAsignadoPorParte),
          );

          const paletActualizado = {
            ...palet,
            asignadoPorParte: nuevoAsignadoPorParte,
            asignado: nuevoAsignado,
          };

          const nuevosPalets = [...prevPalets];
          nuevosPalets[paletIndex] = paletActualizado;

          // Lógica para crear nuevo palet si se completó
          if (
            nuevoAsignado === paletActualizado.ctdPorPalet &&
            paletActualizado.pendienteTotal > 0
          ) {
            const itemOriginalInterno = detallesLocal.find(
              (item) =>
                item.idartp === paletActualizado.idartp &&
                item.nropar === paletActualizado.nropar,
            );

            if (itemOriginalInterno) {
              const pendienteRestante = Math.max(
                0,
                Number(itemOriginalInterno.cantid) -
                  (Number(itemOriginalInterno.ctdaud || 0) +
                    nuevosPalets
                      .filter(
                        (p) =>
                          p.idartp === paletActualizado.idartp &&
                          p.nropar === paletActualizado.nropar,
                      )
                      .reduce((sum, p) => sum + p.asignado, 0)),
              );

              if (pendienteRestante > 0) {
                const ctdPorPaletNueva = calcularCapacidadPalet(
                  itemOriginalInterno,
                  paletActualizado.idpalt,
                  paletActualizado.idpala,
                  tiposPalet,
                  alturasPalet,
                  pendienteRestante,
                  paletActualizado.ctdPorPalet,
                );

                const nuevoPalet = {
                  idPalet: generarIdPaletUnico(),
                  idartl: paletActualizado.idartl,
                  idartp: paletActualizado.idartp,
                  idartf: paletActualizado.idartf,
                  nropar: paletActualizado.nropar,
                  sku: paletActualizado.sku,
                  nombre: paletActualizado.nombre,
                  idpalt: paletActualizado.idpalt,
                  idpala: paletActualizado.idpala,
                  cantid: itemOriginalInterno.cantid,
                  ctdaud: itemOriginalInterno.ctdaud,
                  pendienteTotal: pendienteRestante,
                  asignado: 0,
                  asignadoPorParte: {},
                  paletNumero: nuevosPalets.length + 1,
                  ctdPorPalet: ctdPorPaletNueva,
                  esMultiparte: paletActualizado.esMultiparte,
                  partes: paletActualizado.partes,
                  skusPermitidos: paletActualizado.skusPermitidos,
                };
                setTimeout(() => setPaletActivoId(nuevoPalet.idPalet), 0);
                return [nuevoPalet, ...nuevosPalets];
              }
            }
          }

          return nuevosPalets;
        });
      } else {
        // Comportamiento original para artículos simples
        if (nuevoValor > paletActual.ctdPorPalet) {
          message.error(
            `La cantidad no puede superar ${paletActual.ctdPorPalet} unidades para este palet.`,
          );
          setModalVisible({ status: false, payload: null });
          return;
        }

        const itemOriginal = detallesLocal.find(
          (item) =>
            item.idartp === paletActual.idartp &&
            item.idartl === paletActual.idartl &&
            item.nropar === paletActual.nropar,
        );
        if (itemOriginal) {
          const ctdaudGranel = Number(itemOriginal.ctdaud ?? 0);
          const totalAsignadoEnOtrosPalets = paletsEnProceso
            .filter(
              (p) =>
                p.idPalet !== idPalet &&
                p.idartp === paletActual.idartp &&
                p.idartl === paletActual.idartl &&
                p.nropar === paletActual.nropar,
            )
            .reduce((sum, p) => sum + p.asignado, 0);

          const totalConNuevoValor =
            ctdaudGranel + totalAsignadoEnOtrosPalets + nuevoValor;

          if (totalConNuevoValor > Number(itemOriginal.cantid)) {
            message.error(
              "La cantidad supera el total pendiente del artículo.",
            );
            setModalVisible({ status: false, payload: null });
            return;
          }
        }

        setPaletsEnProceso((prevPalets) => {
          const paletIndex = prevPalets.findIndex((p) => p.idPalet === idPalet);
          if (paletIndex === -1) return prevPalets;

          const paletActualizado = {
            ...prevPalets[paletIndex],
            asignado: nuevoValor,
          };
          const nuevosPalets = [...prevPalets];
          nuevosPalets[paletIndex] = paletActualizado;

          const itemOriginalInterno = detallesLocal.find(
            (item) =>
              item.idartp === paletActualizado.idartp &&
              item.nropar === paletActualizado.nropar,
          );

          if (!itemOriginalInterno) return nuevosPalets;

          const cantidTotal = Number(itemOriginalInterno.cantid ?? 0);
          const ctdaudGranel = Number(itemOriginalInterno.ctdaud ?? 0);

          const totalAsignadoEnPalets = nuevosPalets
            .filter(
              (p) =>
                p.idartp === paletActualizado.idartp &&
                p.nropar === paletActualizado.nropar,
            )
            .reduce((sum, p) => sum + p.asignado, 0);

          const totalActual = totalAsignadoEnPalets + ctdaudGranel;
          const pendienteRestante = cantidTotal - totalActual;

          if (
            nuevoValor === paletActualizado.ctdPorPalet &&
            pendienteRestante > 0
          ) {
            const ctdPorPaletNueva = calcularCapacidadPalet(
              itemOriginalInterno,
              paletActualizado.idpalt,
              paletActualizado.idpala,
              tiposPalet,
              alturasPalet,
              pendienteRestante,
              paletActualizado.ctdPorPalet,
            );

            const nuevoPalet = {
              idPalet: generarIdPaletUnico(),
              idartl: paletActualizado.idartl,
              idartp: paletActualizado.idartp,
              nropar: paletActualizado.nropar,
              sku: paletActualizado.sku,
              nombre: paletActualizado.nombre,
              idpalt: paletActualizado.idpalt,
              idpala: paletActualizado.idpala,
              cantid: itemOriginalInterno.cantid,
              ctdaud: itemOriginalInterno.ctdaud,
              pendienteTotal: pendienteRestante,
              asignado: 0,
              paletNumero: nuevosPalets.length + 1,
              ctdPorPalet: ctdPorPaletNueva,
            };
            setTimeout(() => setPaletActivoId(nuevoPalet.idPalet), 0);
            return [nuevoPalet, ...nuevosPalets];
          }

          return nuevosPalets;
        });
      }

      setModalVisible({ status: false, payload: null });
    } else if (origen === "multipalet") {
      const nuevoValor = Number(valorFinal);

      if (isNaN(nuevoValor) || nuevoValor < 0) {
        message.error("Cantidad inválida.");
        return;
      }

      if (nuevoValor > cantid) {
        message.error("La cantidad supera la disponible.");
        return;
      }

      // Primero, obtenemos el valor ACTUAL del artículo en el palet (antes de cambiar)
      const paletActual = paletsMultiarticulo.find(
        (p) => p.idPalet === idPalet,
      );
      if (!paletActual) {
        message.error("Palet multiartículo no encontrado.");
        return;
      }

      const articuloEnPalet = paletActual.articulos.find(
        (art) => art.sku === sku && art.nropar === parte,
      );

      if (!articuloEnPalet) {
        message.error("Artículo no encontrado en el palet.");
        return;
      }

      const valorAnterior = articuloEnPalet.cantidad;
      const diferencia = nuevoValor - valorAnterior; // Puede ser positiva o negativa

      // Validación de volumen (usamos el palet actual y la diferencia)
      const nuevoVolumenOcupado =
        paletActual.volumenOcupadoM3 +
        diferencia * articuloEnPalet.voltotUnitario;

      if (nuevoVolumenOcupado > paletActual.capacidadVolM3) {
        const espacioDisponibleUnidades = Math.max(
          0,
          Math.floor(
            (paletActual.capacidadVolM3 -
              paletActual.volumenOcupadoM3 +
              valorAnterior * articuloEnPalet.voltotUnitario) /
              articuloEnPalet.voltotUnitario,
          ),
        );
        message.error(
          `No hay suficiente espacio en el palet. Máximo permitido: ${espacioDisponibleUnidades} unidades de este artículo.`,
        );
        return;
      }

      // Actualizar paletsMultiarticulo
      setPaletsMultiarticulo((prev) => {
        const paletIndex = prev.findIndex((p) => p.idPalet === idPalet);
        if (paletIndex === -1) return prev;

        const palet = prev[paletIndex];
        const articuloIndex = palet.articulos.findIndex(
          (art) => art.sku === sku && art.nropar === parte,
        );
        if (articuloIndex === -1) return prev;

        let articulosActualizados = [...palet.articulos];

        if (nuevoValor === 0) {
          // Eliminar el artículo del palet
          articulosActualizados = articulosActualizados.filter(
            (art, idx) => idx !== articuloIndex,
          );
        } else {
          // Actualizar la cantidad
          articulosActualizados[articuloIndex] = {
            ...articulosActualizados[articuloIndex],
            cantidad: nuevoValor,
          };
        }

        let volumenOcupadoM3 = 0;
        let asignadoTotal = 0;
        for (const art of articulosActualizados) {
          volumenOcupadoM3 += art.cantidad * art.voltotUnitario;
          asignadoTotal += art.cantidad;
        }

        const nuevosPalets = [...prev];
        nuevosPalets[paletIndex] = {
          ...palet,
          articulos: articulosActualizados,
          volumenOcupadoM3,
          asignadoTotal,
        };
        return nuevosPalets;
      });

      // Actualizar detallesLocal: sumar la diferencia a ctdaud
      setDetallesLocal((prevDetalles) =>
        prevDetalles.map((item) => {
          if (item.sku === sku && item.nropar === parte) {
            const nuevoCtdaud = Number(item.ctdaud || 0) + diferencia;
            // Aseguramos que no baje de 0 (por si se reduce cantidad)
            return {
              ...item,
              ctdaud: Math.max(0, nuevoCtdaud),
            };
          }
          return item;
        }),
      );

      // Cerrar modal solo tras éxito
      setModalVisible({ status: false, payload: null });
    } else {
      const nuevoValor = Number(valorFinal);

      if (isNaN(nuevoValor) || nuevoValor < 0) {
        message.error("Cantidad inválida.");
        setModalVisible({ status: false, payload: null });
        return;
      }

      const norm = (v) => String(v ?? "").trim();
      const normVto = (v) =>
        String(v ?? "")
          .replaceAll("-", "")
          .trim();

      const tieneLoteVto =
        !!norm(itemActualizado?.lote) && !!normVto(itemActualizado?.vto);

      setDetallesLocal((prev) => {
        if (tieneLoteVto) {
          return prev.map((item) => {
            const esMismaFila =
              norm(item.sku) === norm(sku) &&
              norm(item.nropar) === norm(parte) &&
              norm(item.lote) === norm(itemActualizado.lote) &&
              normVto(item.vto) === normVto(itemActualizado.vto);

            if (esMismaFila) {
              return {
                ...item,
                ctdaud: nuevoValor,
              };
            }

            return item;
          });
        }

        return prev.map((item) => {
          const esMismoItem =
            norm(item.sku) === norm(sku) &&
            norm(item.nropar) === norm(parte) &&
            !norm(item.lote) &&
            !normVto(item.vto);

          if (esMismoItem) {
            return {
              ...item,
              ctdaud: nuevoValor,
            };
          }

          return item;
        });
      });
    }

    setModalVisible({ status: false, payload: null });
  };

  const manejarConfirmacionTeclado = (valor) => {
    setTecladoVisible(false);
    procesarCodigo(valor);
  };

  const eliminarPalet = (idPalet) => {
    // Identificar si es palet mono o multi
    const paletMono = paletsEnProceso.find(
      (p) => p.idPalet === idPalet && !p.esPaletLote,
    );
    const paletMulti = paletsMultiarticulo.find((p) => p.idPalet === idPalet);
    const paletLote = paletsEnProceso.find(
      (p) => p.idPalet === idPalet && p.esPaletLote,
    );

    if (!paletMono && !paletMulti && !paletLote) {
      message.error("Palet no encontrado.");
      return;
    }

    // Si el play/pause activo pertenecía a este palet, limpiarlo: un pin de un
    // palet eliminado no debe seguir identificando el artículo en los escaneos
    // (p. ej. al escanear desde la pestaña Granel debe volver a preguntar el
    // artículo del GTIN, no devolver el que eligió el palet).
    if (loteVtoActivo?.idPalet === idPalet) {
      setLoteVtoActivo(null);
    }

    if (paletMono) {
      // --- Eliminar palet MONOARTÍCULO ---
      setPaletsEnProceso((prev) => prev.filter((p) => p.idPalet !== idPalet));
      if (paletActivoId === idPalet) {
        setPaletActivoId(null);
      }
    } else if (paletMulti) {
      // --- Eliminar palet MULTIARTÍCULO ---
      setPaletsMultiarticulo((prev) =>
        prev.filter((p) => p.idPalet !== idPalet),
      );
      // Si era el palet activo, desactivarlo
      if (paletMultiActivo === idPalet) {
        setPaletMultiActivo(null);
      }
    } else if (paletLote) {
      setPaletsEnProceso((prev) => prev.filter((p) => p.idPalet !== idPalet));
      if (paletActivoId === idPalet) {
        setPaletActivoId(null);
      }
    }

    if (filtroPaletsPorArticulo) {
      // Si venía de un artículo específico → volver a "todos"
      setActiveTab("todos");
      setFiltroPaletsPorArticulo(null);
    }

    // message.success("Palet eliminado correctamente.");
  };

  const handleActualizarConfiguracionPalet = (
    idPalet,
    nuevoIdpalt,
    nuevoIdpala,
    mantenerConfig = false,
    capacidadAsignada, // ← puede ser undefined o un número
  ) => {
    setPaletsEnProceso((prev) =>
      prev.map((palet) => {
        if (palet.idPalet !== idPalet || palet.asignado > 0) {
          return palet;
        }

        //  Si viene capacidadAsignada, la usamos directamente
        if (capacidadAsignada !== undefined) {
          const paletActualizado = {
            ...palet,
            idpalt: nuevoIdpalt,
            idpala: nuevoIdpala,
            ctdPorPalet: capacidadAsignada, // ← valor final del usuario
            asignado: 0,
          };

          // Para la configuración guardada, seguimos usando la lógica original
          if (mantenerConfig) {
            // Pero necesitamos calcular capacidadDelPalet para guardar en configs
            const item = detallesLocal.find((d) =>
              mismoArticuloQuePalet(d, palet),
            );

            let capacidadDelPalet = 1;
            if (item && item.voltot > 0 && item.cantid > 0) {
              const voltotUnitario = item.voltot;
              const tipo = tiposPalet.find((t) => t.idpalt === nuevoIdpalt);
              const altura = alturasPalet.find((a) => a.idpala === nuevoIdpala);

              if (tipo && altura) {
                const volPaletCm3 = tipo.medanc * tipo.medpro * altura.medalt;
                const volPaletM3 = volPaletCm3 / 1_000_000;
                const volUtilM3 = volPaletM3 * 1;
                capacidadDelPalet = Math.max(
                  1,
                  Math.floor(volUtilM3 / voltotUnitario),
                );
              }
            }

            const articuloAConfigurar = detallesLocal.find((x) =>
              mismoArticuloQuePalet(x, palet),
            );

            setConfigs((prev) => {
              const idx = prev.findIndex(
                (c) => c.idartp === palet.idartp && c.nropar === palet.nropar,
              );

              const cfg = {
                idartl: articuloAConfigurar?.idartl,
                idartp: palet.idartp,
                nropar: palet.nropar,
                idpalt: nuevoIdpalt,
                idpala: nuevoIdpala,
                capacidad: capacidadDelPalet, // ← siempre la calculada, no la manual
              };

              if (idx >= 0) {
                const copy = [...prev];
                copy[idx] = cfg;
                return copy;
              }
              return [...prev, cfg];
            });
          }

          return paletActualizado;
        }

        // ❌ Si NO viene capacidadAsignada, usamos la lógica original completa
        const item = detallesLocal.find((d) => mismoArticuloQuePalet(d, palet));

        let nuevaCapacidad = 1;
        let capacidadDelPalet = 1;

        if (item && item.voltot > 0 && item.cantid > 0) {
          const voltotUnitario = item.voltot;
          const tipo = tiposPalet.find((t) => t.idpalt === nuevoIdpalt);
          const altura = alturasPalet.find((a) => a.idpala === nuevoIdpala);

          if (tipo && altura) {
            const volPaletCm3 = tipo.medanc * tipo.medpro * altura.medalt;
            const volPaletM3 = volPaletCm3 / 1_000_000;
            const volUtilM3 = volPaletM3 * 1;

            capacidadDelPalet = Math.max(
              1,
              Math.floor(volUtilM3 / voltotUnitario),
            );
            nuevaCapacidad = Math.min(capacidadDelPalet, item.cantid);
          }
        }

        const paletActualizado = {
          ...palet,
          idpalt: nuevoIdpalt,
          idpala: nuevoIdpala,
          ctdPorPalet: nuevaCapacidad,
          asignado: 0,
        };

        if (mantenerConfig) {
          const articuloAConfigurar = detallesLocal.find((x) =>
            mismoArticuloQuePalet(x, palet),
          );

          setConfigs((prev) => {
            const idx = prev.findIndex(
              (c) => c.idartp === palet.idartp && c.nropar === palet.nropar,
            );

            const cfg = {
              idartl: articuloAConfigurar?.idartl,
              idartp: palet.idartp,
              nropar: palet.nropar,
              idpalt: nuevoIdpalt,
              idpala: nuevoIdpala,
              capacidad: capacidadDelPalet,
            };

            if (idx >= 0) {
              const copy = [...prev];
              copy[idx] = cfg;
              return copy;
            }
            return [...prev, cfg];
          });
        }

        return paletActualizado;
      }),
    );
  };

  const handleMultiploAplicado = (idartl, multip, idPalet) => {
    const factor = Number(multip) || 1;
    setPaletsEnProceso((prev) =>
      prev.map((palet) => {
        const paletIdartl =
          palet.idartl ||
          detallesLocal.find(
            (d) => String(d.sku).trim() === String(palet.sku).trim(),
          )?.idartl;
        if (String(paletIdartl ?? "").trim() !== String(idartl ?? "").trim()) {
          return palet;
        }
        const multiploGuardado = Number(palet.multiploAplicado ?? 1);
        const baseCantid = Number(palet.cantid ?? 0) / multiploGuardado;
        const baseCtdPorPalet =
          Number(palet.ctdPorPalet ?? 0) / multiploGuardado;
        const baseAsignado = Number(palet.asignado ?? 0) / multiploGuardado;
        return {
          ...palet,
          cantid: baseCantid * factor,
          ctdPorPalet: baseCtdPorPalet * factor,
          asignado: baseAsignado * factor,
          multiploAplicado: factor,
        };
      }),
    );
  };

  const calcularCapacidadPreview = (idPalet, idpalt, idpala) => {
    // Buscar el palet en edición
    const palet = paletsEnProceso.find((p) => p.idPalet === idPalet);
    if (!palet || !idpalt || !idpala) return null;

    // Replicar EXACTAMENTE la lógica de handleActualizarConfiguracionPalet
    const item = detallesLocal.find((d) => mismoArticuloQuePalet(d, palet));

    let nuevaCapacidad = 1;

    if (item && item.voltot > 0 && item.cantid > 0) {
      const voltotUnitario = item.voltot;

      const tipo = tiposPalet.find((t) => t.idpalt === idpalt);
      const altura = alturasPalet.find((a) => a.idpala === idpala);

      if (tipo && altura) {
        const volPaletCm3 = tipo.medanc * tipo.medpro * altura.medalt;
        const volPaletM3 = volPaletCm3 / 1_000_000;
        const volUtilM3 = volPaletM3 * 1;

        const capacidadDelPalet = Math.max(
          1,
          Math.floor(volUtilM3 / voltotUnitario),
        );

        nuevaCapacidad = Math.min(capacidadDelPalet, item.cantid);
      }
    }

    return nuevaCapacidad;
  };

  // ------------ Funciones para palets multiartículo ------------
  const crearPaletMultiarticulo = (idpalt, idpala, capacidadUnidades) => {
    // Validar datos mínimos
    const tipo = tiposPalet.find((t) => t.idpalt === idpalt);
    const altura = alturasPalet.find((a) => a.idpala === idpala);
    if (!tipo || !altura) {
      message.error("Tipo o altura de palet inválidos.");
      return;
    }

    // Calcular volumen total útil del palet (en m³)
    const volPaletCm3 = tipo.medanc * tipo.medpro * altura.medalt;
    const volPaletM3 = volPaletCm3 / 1_000_000;
    const volUtilM3 = volPaletM3 * 1; // 85% de utilidad real
    // const volUtilM3 = volPaletM3 * 1; // 85% de utilidad real

    const nuevoPalet = {
      idPalet: `MP-${generarIdPaletUnico().slice(0, 5)}`,
      tipo: idpalt,
      altura: idpala,
      capacidadUnidades, // capacidad en unidades (ingresada por usuario)
      capacidadVolM3: volUtilM3,
      volumenOcupadoM3: 0, // empieza vacío
      articulos: [], // lista de artículos agregados
      asignadoTotal: 0, // total de unidades en el palet
      esMultiarticulo: true, // flag para identificar fácilmente
    };

    setPaletsMultiarticulo((prev) => [nuevoPalet, ...prev]);
    setPaletMultiActivo(nuevoPalet.idPalet); // activar inmediatamente
  };
  // ─── Funciones para palets multiartículo ──────────────────────────────────────
  const cerrarPaletMulti = (idPalet) => {
    setPaletsMultiarticulo((prev) =>
      prev.map((p) => (p.idPalet === idPalet ? { ...p, cerrado: true } : p)),
    );
    // Si era el palet activo, desactivarlo
    if (paletMultiActivo === idPalet) {
      setPaletMultiActivo(null);
    }
  };
  // ------------ Fin Funciones para palets multiartículo ------------
  const articulosGranel = detallesLocal.filter(
    (item) => (item.ctdaud || 0) > 0,
  );
  const activarPalet = (idPalet) => {
    if (idPalet.startsWith("MP-")) {
      // Es multiartículo
      setPaletMultiActivo(idPalet);
      setPaletActivoId(null); // desactivar mono
    } else {
      // Es monoartículo
      setPaletActivoId(idPalet);
      setPaletMultiActivo(null);
    }
  };
  /**
   * Indica si el palet es el más reciente del artículo.
   *
   * No se puede usar la posición en el array porque los palets nuevos se
   * insertan al principio: el último elemento es el palet MÁS VIEJO.
   * Se ordena por paletNumero (mayor = más reciente) y, si no hay ninguno
   * usable, se recurre al orden del array asumiendo el prepend.
   */
  const esPaletMasReciente = (palets, palet) => {
    if (!palet) return false;

    const delArticulo = paletsDelArticulo(palets, palet);
    if (delArticulo.length <= 1) return true;

    const conNumero = delArticulo.filter(
      (p) => Number.isFinite(Number(p.paletNumero)) && p.paletNumero != null,
    );

    if (conNumero.length === delArticulo.length) {
      const mayorNumero = Math.max(
        ...conNumero.map((p) => Number(p.paletNumero)),
      );
      return Number(palet.paletNumero) === mayorNumero;
    }

    // Palets restaurados sin paletNumero: con el prepend, el primero es el
    // más reciente.
    return delArticulo[0]?.idPalet === palet.idPalet;
  };

  // Verifica si hay pendiente real para un artículo para continuar la ejecución manualmente
  const deberiaMostrarBotonContinuar = (palet) => {
    if (!palet) return false;

    const item = detallesLocal.find((d) => mismoArticuloQuePalet(d, palet));
    if (!item) return false;

    const totalAsignado = paletsDelArticulo(paletsEnProceso, item).reduce(
      (sum, p) => sum + (Number(p.asignado) || 0),
      0,
    );

    const pendiente =
      Number(item.cantid) - (Number(item.ctdaud) + totalAsignado);
    if (pendiente <= 0) return false;

    // Solo se ofrece cerrar el palet si no queda ninguno con espacio libre.
    // ctdPorPalet 0 o indefinido se trata como palet sin capacidad
    // conocida: se ignora para no bloquear el botón para siempre.
    const paletsConHueco = paletsDelArticulo(paletsEnProceso, item).filter(
      (p) => {
        const capacidad = Number(p.ctdPorPalet);
        if (!Number.isFinite(capacidad) || capacidad <= 0) return false;
        return Number(p.asignado || 0) < capacidad;
      },
    );

    return paletsConHueco.length === 0;
  };
  // handlers/palletHandlers.js (o dentro del componente si preferís)
  const handleConfirmPaletLote = async ({
    idauds,
    data,
    paletsEnProceso,
    setPaletsEnProceso,
    handleLeerCodigosLote,
    generarIdPaletUnico,
    message,
    onCloseModal, // Callback para cerrar el modal después de confirmar
  }) => {
    try {
      // Leer códigos del lote desde el backend
      const nuevoPaletLote = await handleLeerCodigosLote(idauds, data);

      if (!nuevoPaletLote) {
        onCloseModal?.();
        return false;
      }

      // Validar que no exista ya en proceso
      const existsPaletLote = paletsEnProceso.find(
        (x) => x.alias === nuevoPaletLote?.skupalet,
      );

      if (existsPaletLote) {
        message.error("Ya se ha escaneado el palet ingresado.");
        onCloseModal?.();
        setTimeout(() => {
          const el = document.getElementById(
            `palet-${existsPaletLote.idPalet}`,
          );
          if (el && scrollContainerRef.current) {
            const container = scrollContainerRef.current;
            const containerRect = container.getBoundingClientRect();
            const elementRect = el.getBoundingClientRect();
            const offsetTop =
              elementRect.top - containerRect.top + container.scrollTop;
            container.scrollTo({
              top: offsetTop - containerRect.height / 2 + el.offsetHeight / 2,
              behavior: "smooth",
            });
          }
        }, 150);
        return false;
      }

      // Construir el objeto paletLote con toda la metadata
      const factorMultiplo = Number(nuevoPaletLote?.multiplo) || 1;
      const cantidBase = Number(nuevoPaletLote?.cantid ?? 0);

      const paletLote = {
        ...nuevoPaletLote,
        idPalet: generarIdPaletUnico(),
        alias: nuevoPaletLote.skupalet,
        cantid: cantidBase * factorMultiplo,
        ctdPorPalet: cantidBase * factorMultiplo,
        paletNumero: paletsEnProceso.length + 1,
        esMultiparte: false,
        partes: null,
        asignado: cantidBase * factorMultiplo, // Se cierra con la cantidad escaneada
        asignadoPorParte: {},
        skusPermitidos: [nuevoPaletLote.sku],
        esPaletLote: true,
        multiploAplicado: factorMultiplo,
      };

      setPaletsEnProceso((prev) => [paletLote, ...prev]);
      // Cerrar modal y notificar éxito
      onCloseModal?.();
      // message.success("Palet de lote agregado correctamente");
      return true;
    } catch (error) {
      message.error("Error al procesar el palet. Intentá nuevamente.");
      onCloseModal?.();
      return false;
    }
  };

  const handleOnConfirm = useCallback(
    async (data) => {
      await handleConfirmPaletLote({
        idauds,
        data,
        paletsEnProceso,
        setPaletsEnProceso,
        handleLeerCodigosLote,
        generarIdPaletUnico,
        message,
        onCloseModal: () => setPaletLoteActivo(false),
      });
    },
    [
      idauds,
      paletsEnProceso,
      setPaletsEnProceso,
      handleLeerCodigosLote,
      generarIdPaletUnico,
      message,
    ],
  );

  //  Handler para cancelar el modal de Palet Lote
  const handleOnCancel = useCallback(() => {
    if (barcodeData?.hasData) {
      // Si hay datos escaneados, mostrar confirmación
      Modal.confirm({
        title: "¿Cancelar carga de palet lote?",
        content: "Los datos ingresados se perderán. ¿Deseás continuar?",
        okText: "Sí, cancelar",
        okType: "danger",
        cancelText: "No, continuar",
        centered: true,
        onOk: () => {
          setBarcodeData({
            hasData: false,
            values: { cb1: "", cb2: "", cb3: "" },
          });
          setCodigoDetectado(null);
          setPaletLoteActivo(false);
        },
      });
    } else {
      // Si no hay datos, cerrar directo
      setPaletLoteActivo(false);
    }
  }, [barcodeData?.hasData]);

  const headerComponent = (
    <HeaderBack
      modulo={"Auditar SMA"}
      onBack={handleGoBack}
      data={{ headerTitle: auditoriaSMA?.numeroComprobanteSMA }}
      acciones={
        <div style={{ display: "flex", gap: 12 }}>
          {ordenActiva && (
            <span
              onClick={abrirTeclado}
              style={{ cursor: "pointer", display: "flex" }}
            >
              <ScanOutlined style={{ fontSize: "36px", color: "white" }} />
            </span>
          )}
          <span
            onClick={handleAccion}
            style={{
              cursor: procesandoAccion ? "default" : "pointer",
              display: "flex",
              pointerEvents: procesandoAccion ? "none" : "auto",
              opacity: procesandoAccion ? 0.6 : 1,
            }}
          >
            {procesandoAccion ? (
              <SyncOutlined spin style={{ fontSize: "36px", color: "white" }} />
            ) : (
              accionActual?.icon
            )}
          </span>
        </div>
      }
    />
  );

  const norm = (v) => (v == null ? "" : String(v).trim());
  const normVto = (v) => norm(v).replaceAll("-", "");

  // Render: Modo recepción (con tabs y paletizado)
  const renderModoRecepcion = () => (
    <Row gutter={[8, 8]} justify="start" align="stretch">
      <Col
        span={24}
        style={{
          position: "sticky",
          top: -10,
          zIndex: 10,
          padding: 0,
          backgroundColor: darkMode ? "#222" : "#fafafa",
          borderRadius: 6,
        }}
      >
        <TabSelector
          activeTab={activeTab}
          setActiveTab={(nuevoTab) => {
            if (nuevoTab === "palet") {
              setFiltroPaletsPorArticulo(null);
            }
            setActiveTab(nuevoTab);
          }}
          jaula={jaula}
          darkMode={darkMode}
        />
      </Col>

      {/* --------- Tab Todos ---------*/}
      {activeTab === "todos"
        ? detallesLocal.map((item) => (
            <TodosCard
              id={getItemDomId(item)}
              key={`${norm(item.sku)}|${norm(item.nropar)}|${norm(item.lote)}|${normVto(item.vto)}`}
              item={item}
              darkMode={darkMode}
              getColorEstado={(item) =>
                getColorEstado(
                  paletsEnProceso,
                  item,
                  darkMode,
                  detallesLocal,
                  paletsMultiarticulo,
                )
              }
              ordenActiva={ordenActiva}
              setModalVisible={setModalVisible}
              handleSelectForPalet={handleSelectForPalet}
              getTotalAuditadoYConteoPalets={(item) =>
                getTotalAuditadoYConteoPalets(
                  paletsEnProceso,
                  item,
                  detallesLocal,
                  paletsMultiarticulo,
                )
              }
              esRecepcionMercaderia={esRecepcionMercaderia ? true : false}
            />
          ))
        : null}

      {/* --------- Tab Granel ---------*/}
      {activeTab === "granel" ? (
        articulosGranel.length > 0 ? (
          articulosGranel.map((item) => (
            <GranelCard
              id={getItemDomId(item)}
              key={`${norm(item.sku)}|${norm(item.nropar)}|${norm(item.lote)}|${normVto(item.vto)}`}
              item={item}
              darkMode={darkMode}
              ordenActiva={ordenActiva}
              setModalVisible={setModalVisible}
              loteVtoActivo={loteVtoActivo}
              onSetLoteVtoActivo={setLoteVtoActivo}
              loteVtoActivoRef={loteVtoActivoRef}
              colorEstado={getColorEstado(
                paletsEnProceso,
                item,
                darkMode,
                detallesLocal,
                paletsMultiarticulo,
              )}
            />
          ))
        ) : (
          <Col span={24}>
            <Card style={{ textAlign: "center", padding: 24 }}>
              <Text style={{ fontSize: 17 }}>
                No hay artículos auditados a granel.
              </Text>
            </Card>
          </Col>
        )
      ) : null}

      {/* --------- Tab Palet ---------*/}
      {activeTab === "palet" && (
        <>
          {esRecepcionMercaderia && !filtroPaletsPorArticulo && (
            <>
              {ordenActiva && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "8px",
                    width: "100%",
                  }}
                >
                  <div
                    onClick={() => setModalPaletMultiVisible(true)}
                    style={{
                      width: "100%",
                      maxWidth: "300px",
                      padding: "16px 24px",
                      backgroundColor: "#fff",
                      border: "1px solid #388e3c",
                      color: "#000",
                      borderRadius: "8px",
                      textAlign: "center",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      fontSize: "17px",
                      transition: "background-color 0.2s ease",
                    }}
                  >
                    <AppstoreAddOutlined style={{ fontSize: 21 }} />
                    Crear palet personalizado
                  </div>

                  <div
                    onClick={() => setPaletLoteActivo(true)}
                    style={{
                      width: "100%",
                      maxWidth: "300px",
                      padding: "16px 24px",
                      backgroundColor: "#fff",
                      border: "1px solid grey",
                      color: "#000",
                      borderRadius: "8px",
                      textAlign: "center",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      fontSize: "17px",
                      transition: "background-color 0.2s ease",
                    }}
                  >
                    <InsertRowBelowOutlined style={{ fontSize: 21 }} />
                    Crear palet (lote)
                  </div>
                </div>
              )}
            </>
          )}

          {paletsEnProceso
            .filter((palet) => {
              if (!filtroPaletsPorArticulo) return true;
              return mismoArticuloQuePalet(filtroPaletsPorArticulo, palet);
            })
            .map((palet) => {
              // El palet más reciente NO es el último del array: los palets
              // nuevos se insertan al principio (prepend) para que queden
              // arriba, cerca de donde se está trabajando. Por eso el más
              // reciente se busca por paletNumero y no por posición.
              const mostrarBotonContinuar =
                ordenActiva &&
                !paletMultiActivo &&
                esPaletMasReciente(paletsEnProceso, palet) &&
                deberiaMostrarBotonContinuar(palet);

              return (
                <React.Fragment key={palet.idPalet}>
                  <PaletCard
                    key={palet.idPalet}
                    id={getItemDomId(palet)}
                    palet={palet}
                    darkMode={darkMode}
                    tiposPalet={tiposPalet}
                    alturasPalet={alturasPalet}
                    ordenActiva={ordenActiva}
                    setModalVisible={setModalVisible}
                    isActive={
                      !paletMultiActivo && palet.idPalet === paletActivoId
                    }
                    onActualizarConfiguracion={
                      handleActualizarConfiguracionPalet
                    }
                    onCalcularCapacidad={calcularCapacidadPreview}
                    onEliminarPalet={eliminarPalet}
                    onActivarPalet={activarPalet}
                    detallesLocal={detallesLocal}
                    onMultiploAplicado={handleMultiploAplicado}
                  />
                  {mostrarBotonContinuar && filtroPaletsPorArticulo && (
                    <Col
                      span={24}
                      style={{ textAlign: "center", marginTop: 8 }}
                    >
                      <Button
                        type="dashed"
                        size="large"
                        icon={
                          <BorderBottomOutlined
                            style={{
                              color: "#000",
                              fontSize: 26,
                            }}
                          />
                        }
                        onClick={() => {
                          const item = detallesLocal.find((i) =>
                            mismoArticuloQuePalet(i, palet),
                          );
                          if (!item) return;

                          const totalAsignado = paletsDelArticulo(
                            paletsEnProceso,
                            item,
                          ).reduce(
                            (sum, p) => sum + (Number(p.asignado) || 0),
                            0,
                          );

                          const pendienteRestante =
                            Number(item.cantid) -
                            (Number(item.ctdaud) + totalAsignado);

                          const ctdPorPaletNueva = Math.min(
                            palet.ctdPorPalet,
                            pendienteRestante,
                          );

                          const nuevoPalet = {
                            ...palet,
                            idPalet: generarIdPaletUnico(),
                            asignado: 0,
                            ctdPorPalet: ctdPorPaletNueva,
                            pendienteTotal: pendienteRestante,
                            paletNumero: paletsEnProceso.length + 1,
                          };

                          setPaletsEnProceso((prev) => [nuevoPalet, ...prev]);
                          setTimeout(
                            () => setPaletActivoId(nuevoPalet.idPalet),
                            0,
                          );
                        }}
                      >
                        Continuar paletizando ({palet.sku})
                      </Button>
                    </Col>
                  )}
                </React.Fragment>
              );
            })}
          {/* Palets multiartículo */}
          {paletsMultiarticulo.length > 0 &&
            paletsMultiarticulo.map((palet) => (
              <PaletMultiCard
                key={palet.idPalet}
                palet={palet}
                darkMode={darkMode}
                tiposPalet={tiposPalet}
                alturasPalet={alturasPalet}
                isActive={palet.idPalet === paletMultiActivo}
                onCerrarPalet={cerrarPaletMulti}
                ordenActiva={ordenActiva}
                setModalVisible={setModalVisible}
                onEliminarPalet={eliminarPalet}
                onActivarPalet={activarPalet}
                loteVtoActivo={loteVtoActivo}
                onSetLoteVtoActivo={setLoteVtoActivo}
              />
            ))}

          {paletsEnProceso.length === 0 && paletsMultiarticulo.length === 0 && (
            <Col span={24}>
              <Card style={{ textAlign: "center", padding: 24 }}>
                <Text style={{ fontSize: 17 }}>No hay palets generados.</Text>
              </Card>
            </Col>
          )}
        </>
      )}

      {ordenActiva && (
        <>
          <Divider style={{ margin: 6 }} />
          <Col span={24}>
            <Popconfirm
              title="¿Desea completar la auditoria?"
              onConfirm={async () => {
                handleCompletarAuditoriaSMA();
              }}
              okText="Sí"
              cancelText="No"
              okButtonProps={{ size: "large" }}
              cancelButtonProps={{ size: "large" }}
              styles={{
                body: {
                  padding: "16px 20px",
                  minWidth: "300px",
                  fontSize: "17px",
                },
              }}
            >
              <Button type="primary" size="large" block>
                Completar auditoria
              </Button>
            </Popconfirm>
          </Col>
        </>
      )}
    </Row>
  );

  // Render: Modo simple (solo TodosCard)
  const renderModoSimple = () => (
    <Row gutter={[8, 8]} justify="start" align="stretch">
      {detallesLocal.map((item) => (
        <TodosCard
          id={getItemDomId(item)}
          key={`${item.idartp}-${item.nropar}-${item.sku}`}
          item={item}
          darkMode={darkMode}
          getColorEstado={(item) =>
            getColorEstado(
              paletsEnProceso,
              item,
              darkMode,
              detallesLocal,
              paletsMultiarticulo,
            )
          }
          ordenActiva={ordenActiva}
          setModalVisible={setModalVisible}
          handleSelectForPalet={handleSelectForPalet}
          getTotalAuditadoYConteoPalets={(item) =>
            getTotalAuditadoYConteoPalets(
              paletsEnProceso,
              item,
              detallesLocal,
              paletsMultiarticulo,
            )
          }
          esRecepcionMercaderia={esRecepcionMercaderia === 1 ? true : false} // Para activar lógica específica dentro de la card general
        />
      ))}

      {ordenActiva && (
        <>
          <Divider style={{ margin: 6 }} />
          <Col span={24}>
            <Popconfirm
              title="¿Desea completar la auditoria?"
              onConfirm={async () => {
                handleCompletarAuditoriaSMA();
              }}
              okText="Sí"
              cancelText="No"
              okButtonProps={{ size: "large" }}
              cancelButtonProps={{ size: "large" }}
              styles={{
                body: {
                  padding: "16px 20px",
                  minWidth: "300px",
                  fontSize: "17px",
                },
              }}
            >
              <Button type="primary" size="large" block>
                Completar auditoria
              </Button>
            </Popconfirm>
          </Col>
        </>
      )}
    </Row>
  );

  return (
    <AppLayout
      darkMode={darkMode}
      setDarkMode={setDarkMode}
      header={headerComponent}
    >
      <div
        ref={scrollContainerRef}
        style={{
          flex: 1,
          minHeight: 0,
          padding: "8px",
          overflowY: "auto",
          overflowX: "hidden",
          backgroundColor: darkMode ? "#1f1f1f" : "#fafafa",
        }}
      >
        {loading && <Loader />}

        {!loading &&
          auditoriaSMA &&
          (esRecepcionMercaderia ? renderModoRecepcion() : renderModoSimple())}

        {!loading && !auditoriaSMA && (
          <Card
            style={{
              textAlign: "center",
              backgroundColor: darkMode ? "#1f1f1f" : "#fafafa",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "32px",
            }}
          >
            <Text type="secondary" style={{ fontSize: "19px" }}>
              Auditoria SMA no encontrada.
            </Text>
          </Card>
        )}
      </div>

      {/* Modales */}
      {modalVisible?.status && (
        <Suspense fallback={null}>
          <ModalTecladoCantidad
            darkMode={darkMode}
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            onConfirm={handleConfirmModal}
            detallesLocal={detallesLocal}
          />
        </Suspense>
      )}

      {tecladoVisible && (
        <Suspense fallback={null}>
          <ModalTecladoAlfanumerico
            open={tecladoVisible}
            onClose={() => setTecladoVisible(false)}
            darkMode={darkMode}
            letras={["A", "B", "C", "J", "P", "#"]} // OTERO
            // letras={["A", "B", "C", "D", "P", "#"]} // OTROS
            onConfirm={manejarConfirmacionTeclado}
            title="Ingrese ubicación o código"
          />
        </Suspense>
      )}

      {modalPaletManual.visible && (
        <Suspense fallback={null}>
          <Modal
            title="Configuración de palet manual"
            open={true}
            onCancel={() => setModalPaletManual({ visible: false, item: null })}
            footer={null}
            centered
          >
            <Text
              type="secondary"
              style={{ display: "block", marginBottom: 16 }}
            >
              El artículo no tiene configuración de palet definida. Por favor,
              indique el tipo y capacidad para iniciar la paletización manual.
            </Text>
            <ManualPaletForm
              item={modalPaletManual.item}
              tiposPalet={tiposPalet}
              alturasPalet={alturasPalet}
              onClose={() =>
                setModalPaletManual({ visible: false, item: null })
              }
              onConfirm={(idpalt, idpala, capacidad) => {
                setModalPaletManual({ visible: false, item: null });
                iniciarPaletizacionManual(
                  modalPaletManual.item,
                  idpalt,
                  idpala,
                  capacidad,
                );
              }}
              darkMode={darkMode}
            />
          </Modal>
        </Suspense>
      )}

      {modalPaletMultiVisible && (
        <Suspense fallback={null}>
          <Modal
            title="Nuevo palet personalizado"
            open={modalPaletMultiVisible}
            onCancel={() => setModalPaletMultiVisible(false)}
            footer={null}
            centered
          >
            <Suspense fallback={null}>
              <ManualPaletMultiForm
                tiposPalet={tiposPalet}
                alturasPalet={alturasPalet}
                onConfirm={(idpalt, idpala, capacidad) => {
                  crearPaletMultiarticulo(idpalt, idpala, capacidad);
                  setModalPaletMultiVisible(false);
                }}
                onCancel={() => setModalPaletMultiVisible(false)}
                darkMode={darkMode}
              />
            </Suspense>
          </Modal>
        </Suspense>
      )}

      {usaLote === "true" && paletLoteActivo && (
        <Suspense fallback={null}>
          <Modal
            title="Nuevo palet lote"
            open={paletLoteActivo}
            onCancel={handleOnCancel}
            footer={null}
            centered
            maskClosable={false}
          >
            <Suspense fallback={null}>
              <ManualBarcodeInput
                onConfirm={handleOnConfirm}
                onCancel={handleOnCancel}
                onDataChange={(data) => setBarcodeData(data)}
                initialCode={codigoDetectado}
                darkMode={darkMode}
              />
            </Suspense>
          </Modal>
        </Suspense>
      )}

      {modalLoteVisible && (
        <Suspense fallback={null}>
          <ModalLoteVto
            open={modalLoteVisible}
            onCancel={() => setModalLoteVisible(false)}
            onConfirm={async () => {
              if (activeTab !== "palet") {
                await handleConfirmarLoteVtoGranel();
              } else {
                await handleConfirmarProcesarLoteVto();
              }
            }}
            loteInput={loteInput}
            setLoteInput={setLoteInput}
            vtoInput={vtoInput}
            setVtoInput={setVtoInput}
            nombreArticulo={modalLoteNombreArt}
          />
        </Suspense>
      )}

      <ModalDiferenciasSMA
        open={modalDiferencias.open}
        descri={modalDiferencias.descri}
        diferencias={modalDiferencias.diferencias}
        onClose={() =>
          setModalDiferencias({ open: false, descri: "", diferencias: [] })
        }
      />

      <ModalSeleccionSku
        open={modalSeleccionSku.open}
        items={modalSeleccionSku.items}
        onSelect={cerrarSeleccionSku}
        onCancel={() => cerrarSeleccionSku(null)}
      />

      <ModalSeleccionVLX
        open={modalLoteVtoVLX.open}
        items={modalLoteVtoVLX.items}
        onSelect={confirmarLoteVtoVLX}
        onClose={() =>
          setModalLoteVtoVLX({
            open: false,
            items: [],
            ubicacionActual: null,
            sku: null,
          })
        }
      />
    </AppLayout>
  );
};

export default DetalleAuditaSMA;
